!(function(r) {
  var n = {};
  function o(e) {
    if (n[e]) return n[e].exports;
    var t = (n[e] = { i: e, l: !1, exports: {} });
    return r[e].call(t.exports, t, t.exports, o), (t.l = !0), t.exports;
  }
  (o.m = r),
    (o.c = n),
    (o.d = function(e, t, r) {
      o.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: r });
    }),
    (o.r = function(e) {
      "undefined" != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
        Object.defineProperty(e, "__esModule", { value: !0 });
    }),
    (o.t = function(t, e) {
      if ((1 & e && (t = o(t)), 8 & e)) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var r = Object.create(null);
      if (
        (o.r(r),
        Object.defineProperty(r, "default", { enumerable: !0, value: t }),
        2 & e && "string" != typeof t)
      )
        for (var n in t)
          o.d(
            r,
            n,
            function(e) {
              return t[e];
            }.bind(null, n)
          );
      return r;
    }),
    (o.n = function(e) {
      var t =
        e && e.__esModule
          ? function() {
              return e.default;
            }
          : function() {
              return e;
            };
      return o.d(t, "a", t), t;
    }),
    (o.o = function(e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }),
    (o.p = ""),
    o((o.s = 47));
})([
  function(e, t) {
    Date.now =
      Date.now ||
      function() {
        return new Date().getTime();
      };
    function r() {}
    var n = Date.now(),
      o = {
        noop: r,
        warn: (function() {
          var e = "object" == typeof console ? console.warn : r;
          try {
            var t = { warn: e };
            t.warn.call(t);
          } catch (e) {
            return r;
          }
          return e;
        })(),
        key: "__bl",
        selfErrKey: "ARMS_SDK_ERROR",
        selfErrPage: "ARMSSDK",
        win: "object" == typeof window && window.document ? window : void 0,
        regionMap: {
          cn: "https://arms-retcode.aliyuncs.com/r.png?",
          sg: "https://arms-retcode-sg.aliyuncs.com/r.png?",
          sg_2: "https://retcode-sg-lazada.arms.aliyuncs.com/r.png?",
          daily: "http://arms-retcode-daily.alibaba.net/r.png?",
          daily_2: "https://arms-retcode-daily.alibaba.net/r.png?",
          us: "https://retcode-us-west-1.arms.aliyuncs.com/r.png?",
          tw: "https://arms-retcode.orientalgame.com.tw/r.png?",
          tw_sg: "https://arms-retcode-sg.orientalgame.com.tw/r.png?",
          hz_finance: "https://arms-retcode-hz-finance.aliyuncs.com/r.png?",
        },
        defaultImgUrl: "https://arms-retcode.aliyuncs.com/r.png?",
        createObject: function(e) {
          if (Object.create) return Object.create(e);
          function t() {}
          return (t.prototype = e), new t();
        },
        each: function(e, t) {
          var r = 0,
            n = e.length;
          if (this.T(e, "Array"))
            for (; r < n && !1 !== t.call(e[r], e[r], r); r++);
          else for (r in e) if (!1 === t.call(e[r], e[r], r)) break;
          return e;
        },
        safetyCall: function(e, t, r) {
          if ("function" != typeof e) return r;
          try {
            return e.apply(this, t);
          } catch (e) {
            return r;
          }
        },
        T: function(e, t) {
          e = Object.prototype.toString
            .call(e)
            .substring(8)
            .replace("]", "");
          return t ? e === t : e;
        },
        filterByRule: function(t, e) {
          if (!t) return "";
          if (!e) return t;
          var r = this,
            n = r.T(e);
          return "Function" === n
            ? r.safetyCall(e, [t], t)
            : "Array" === n
            ? (this.each(e, function(e) {
                t = r.filterByRule(t, e);
              }),
              t)
            : "Object" === n
            ? t.replace(e.rule, e.target || "")
            : t.replace(e, "");
        },
        ignoreByRule: function(e, t) {
          if (!e || !t) return !1;
          if (
            ((this.isString(t) || t.source || "Function" === this.T(t)) &&
              (t = [t]),
            !this.isArray(t))
          )
            return (
              this.warn(
                "[arms] invalid rules of ignore config, (list of) String/RegExp/Funcitons are available"
              ),
              !1
            );
          for (var r, n = [], o = 0, i = t.length; o < i; o++)
            if (((r = t[o]), this.isString(r)))
              n.push(r.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1"));
            else if (r && r.source) n.push(r.source);
            else if (
              r &&
              "Function" === this.T(r) &&
              !0 === this.safetyCall(r, [e], !1)
            )
              return !0;
          var a = new RegExp(n.join("|"), "i");
          return !!(n.length && a.test && a.test(e));
        },
        J: function(e) {
          if (!e || "string" != typeof e) return e;
          var t = null;
          try {
            t = JSON.parse(e);
          } catch (e) {}
          return t;
        },
        pick: function(e) {
          return 1 === e || 1 === Math.ceil(Math.random() * e);
        },
        verifyConfig: function(e) {
          var t, r;
          return (
            "sample" in e &&
              (1 <=
                (r =
                  0 <
                    (r =
                      (r = t = e.sample) && /^\d+(\.\d+)?%$/.test(t)
                        ? parseInt(100 / parseFloat(t))
                        : r) && r < 1
                    ? parseInt(1 / r)
                    : r) && r <= 100
                ? (e.sample = r)
                : delete e.sample),
            e
          );
        },
        on: function(r, n, o, i, a) {
          return (
            r.addEventListener
              ? r.addEventListener(
                  n,
                  function e(t) {
                    i && r.removeEventListener(n, e, a), o.call(this, t);
                  },
                  (a = a || !1)
                )
              : r.attachEvent &&
                r.attachEvent("on" + n, function e(t) {
                  i && r.detachEvent("on" + n, e), o.call(this, t);
                }),
            this
          );
        },
        off: function(e, t, r) {
          return (
            r &&
              (e.removeEventListener
                ? e.removeEventListener(t, r)
                : e.detachEvent && e.detachEvent(t, r)),
            this
          );
        },
        delay: function(e, t) {
          return -1 === t ? (e(), null) : setTimeout(e, t || 0);
        },
        ext: function(e) {
          for (var t = 1, r = arguments.length; t < r; t++) {
            var n,
              o = arguments[t];
            for (n in o)
              Object.prototype.hasOwnProperty.call(o, n) && (e[n] = o[n]);
          }
          return e;
        },
        sub: function(e, r) {
          var n = {};
          return (
            this.each(e, function(e, t) {
              -1 !== r.indexOf(t) && (n[t] = e);
            }),
            n
          );
        },
        uu: function() {
          for (
            var e,
              t,
              r = 20,
              n = new Array(r),
              o = Date.now()
                .toString(36)
                .split("");
            0 < r--;

          )
            (t = (e = (36 * Math.random()) | 0).toString(36)),
              (n[r] = e % 3 ? t : t.toUpperCase());
          for (var i = 0; i < 8; i++) n.splice(3 * i + 2, 0, o[i]);
          return n.join("");
        },
        seq: function() {
          return (n++).toString(36);
        },
        decode: function(e) {
          try {
            e = decodeURIComponent(e);
          } catch (e) {}
          return e;
        },
        encode: function(e, t) {
          try {
            e = t
              ? encodeURIComponent(e)
                  .replace(/\(/g, "%28")
                  .replace(/\)/g, "%29")
              : encodeURIComponent(e);
          } catch (e) {}
          return e;
        },
        serialize: function(e) {
          var t,
            r = [];
          for (t in (e = e || {}))
            Object.prototype.hasOwnProperty.call(e, t) &&
              void 0 !== e[t] &&
              r.push(t + "=" + this.encode(e[t], "msg" === t));
          return r.join("&");
        },
        checkAPI: function(e, t) {
          if (!e || "string" != typeof e) return !1;
          var r = /arms-retcode[\w-]*\.aliyuncs/.test(e);
          return !(r = !r && t ? /(\.png)|(\.gif)|(alicdn\.com)/.test(e) : r);
        },
        checkAutoError: function(e) {
          return !(!e || !e.message || /failed[\w\s]+fetch/i.test(e.message));
        },
        cutUrlSearch: function(e) {
          return e && "string" == typeof e
            ? e.replace(/^(https?:)?\/\//, "").replace(/\?.*$/, "")
            : "";
        },
        removeUrlSearch: function(e) {
          return e && "string" == typeof e ? e.replace(/\?.*$/, "") : "";
        },
        createFakeToString: function(e) {
          return function() {
            return e + "() { [native code] }";
          };
        },
        checkSameOrigin: function(e, t) {
          if (!t || !e) return !1;
          var r = "//" + t.split("/")[2];
          return (
            e === t ||
            e.slice(0, t.length + 1) === t + "/" ||
            e === r ||
            e.slice(0, r.length + 1) === r + "/" ||
            !/^(\/\/|http:|https:).*/.test(e)
          );
        },
        getRandIP: function() {
          for (var e = [], t = 0; t < 4; t++) {
            var r = Math.floor(256 * Math.random());
            e[t] = (15 < r ? "" : "0") + r.toString(16);
          }
          return e.join("").replace(/^0/, "1");
        },
        getSortNum: function(e) {
          return e
            ? 1e3 <= (e += 1) && e <= 9999
              ? e
              : e < 1e3
              ? e + 1e3
              : (e % 1e4) + 1e3
            : 1e3;
        },
        getRandNum: function(e) {
          return !e || "string" != typeof e || e.length < 5
            ? this.getNum(5)
            : e.substring(e.length - 5);
        },
        getNum: function(e) {
          for (var t = [], r = 0; r < e; r++) {
            var n = Math.floor(16 * Math.random());
            t[r] = n.toString(16);
          }
          return t.join("");
        },
        getCurDomain: function() {
          return (location && location.hostname) || "";
        },
        parseFetchHeaders: function(e) {
          if (!e) return {};
          var t = {};
          try {
            if ("function" == typeof e.keys)
              for (var r = e.keys(), n = r.next(); !n.done; ) {
                var o = n.value;
                (t[o] = e.get(o)), (n = r.next());
              }
            else t = e;
          } catch (e) {
            t = {};
          }
          return t;
        },
        parseXhrHeaders: function(e) {
          if (!e && "string" != typeof e) return {};
          var t = {};
          try {
            t = e.split("\r\n").reduce(function(e, t) {
              t = t.split(": ");
              return (e[t[0]] = t[1]), e;
            }, {});
          } catch (e) {
            t = {};
          }
          return t;
        },
        getQuerys: function(e) {
          if (!e) return "";
          var t,
            r,
            n,
            o = {};
          try {
            var i = [];
            if (
              0 <
              (i =
                0 <= e.indexOf("?")
                  ? e.substring(e.indexOf("?") + 1, e.length).split("&")
                  : i).length
            )
              for (var a in i)
                (r = (t = i[a].split("="))[0]), (n = t[1]), (o[r] = n);
          } catch (e) {
            o = {};
          }
          return o;
        },
        getFetchSnapshot: function(e, t, r) {
          try {
            var n = (e && "string" != typeof e[0] ? e[0].url : e[0]) || "",
              o = (e && "string" != typeof e[0] ? e[0] : e[1]) || {},
              i =
                "POST" === o.method.toUpperCase() ? o.body : this.getQuerys(n),
              a = {
                originApi: n,
                method: o.method || "unknown",
                params: i,
                response: t || "",
                reqHeaders: this.parseFetchHeaders(o.headers || null),
                resHeaders: this.parseFetchHeaders(r),
              },
              s =
                ("function" == typeof encodeURIComponent &&
                  JSON &&
                  encodeURIComponent(JSON.stringify(a))) ||
                "{}";
          } catch (e) {
            s = "{}";
          }
          return s;
        },
        getXhrSnapshot: function(e, t, r) {
          if (!e || !t || !r) return {};
          var n, o;
          try {
            var i = "";
            "" === r.responseType || "text" === r.responseType
              ? (i = r.responseText)
              : "document" === r.responseType && (i = r.responseXML),
              (n = {
                originApi: e,
                method: t,
                params: this.getQuerys(e),
                response: i,
                reqHeaders: {},
                resHeaders: this.parseXhrHeaders(
                  ("function" == typeof r.getAllResponseHeaders &&
                    r.getAllResponseHeaders()) ||
                    ""
                ),
              }),
              (o =
                ("function" == typeof encodeURIComponent &&
                  JSON &&
                  encodeURIComponent(JSON.stringify(n))) ||
                "{}");
          } catch (e) {
            o = "{}";
          }
          return o;
        },
        isRobot: function() {
          var e = [
            "nuhk",
            "googlebot/",
            "googlebot-image",
            "yammybot",
            "openbot",
            "slurp",
            "msnbot",
            "ask jeeves/teoma",
            "ia_archiver",
            "baiduspider",
            "bingbot/",
            "adsbot",
          ];
          if (!navigator || "string" != typeof navigator.userAgent) return !1;
          try {
            for (
              var t = navigator.userAgent.toLowerCase(), r = 0;
              r < e.length;
              r++
            ) {
              var n = e[r];
              if (0 <= t.lastIndexOf(n)) return !0;
            }
          } catch (e) {
            this.warn("[arms] useragent parse error");
          }
          return !1;
        },
        isFunction: function(e) {
          return "function" == typeof e;
        },
        isPlainObject: function(e) {
          return "[object Object]" === Object.prototype.toString.call(e);
        },
        isString: function(e) {
          return "[object String]" === Object.prototype.toString.call(e);
        },
        isArray: function(e) {
          return "[object Array]" === Object.prototype.toString.call(e);
        },
        joinRegExp: function(e) {
          for (var t, r = [], n = 0, o = e.length; n < o; n++)
            (t = e[n]),
              this.isString(t)
                ? r.push(t.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1"))
                : t && t.source && r.push(t.source);
          return new RegExp(r.join("|"), "i");
        },
        reWriteMethod: function(e, t, r) {
          var n;
          null !== e && ((n = e[t]), (e[t] = r(n)));
        },
        checkSDKError: function(e, t) {
          return (
            !(!e && !t) &&
            (!!new RegExp(this.selfErrKey, "i").test(e) ||
              !!this.ignoreByRule(t, [
                /retcode.alicdn.com\/retcode\/bl.js/,
                /g.alicdn.com\/retcode\/cloud-sdk\/bl.js/,
                /laz-g-cdn.alicdn.com\/retcode\/cloud-sdk\/bl.js/,
                /local.taobao.com:8880\/build\/bl/,
              ]))
          );
        },
        sdkError: function(e) {
          return { msg: e, message: this.selfErrKey };
        },
        dealParam: function(e, t, r) {
          var n = {};
          try {
            n = this.isPlainObject(e)
              ? this.ext(
                  { key: e.key || "default", val: e.val || e.value || r },
                  e,
                  { begin: Date.now() }
                )
              : { key: e || "default", val: t || r, begin: Date.now() };
          } catch (e) {
            this.warn("[retcode] baseLog error: " + e);
          }
          return n;
        },
      };
    e.exports = o;
  },
  function(e, t, r) {
    "use strict";
    var o = r(5),
      r = r(15),
      n = Object.prototype.toString;
    function i(e) {
      return "[object Array]" === n.call(e);
    }
    function a(e) {
      return null !== e && "object" == typeof e;
    }
    function s(e) {
      return "[object Function]" === n.call(e);
    }
    function c(e, t) {
      if (null != e)
        if (("object" == typeof e || i(e) || (e = [e]), i(e)))
          for (var r = 0, n = e.length; r < n; r++) t.call(null, e[r], r, e);
        else
          for (var o in e)
            Object.prototype.hasOwnProperty.call(e, o) &&
              t.call(null, e[o], o, e);
    }
    e.exports = {
      isArray: i,
      isArrayBuffer: function(e) {
        return "[object ArrayBuffer]" === n.call(e);
      },
      isBuffer: r,
      isFormData: function(e) {
        return "undefined" != typeof FormData && e instanceof FormData;
      },
      isArrayBufferView: function(e) {
        return (e =
          "undefined" != typeof ArrayBuffer && ArrayBuffer.isView
            ? ArrayBuffer.isView(e)
            : e && e.buffer && e.buffer instanceof ArrayBuffer);
      },
      isString: function(e) {
        return "string" == typeof e;
      },
      isNumber: function(e) {
        return "number" == typeof e;
      },
      isObject: a,
      isUndefined: function(e) {
        return void 0 === e;
      },
      isDate: function(e) {
        return "[object Date]" === n.call(e);
      },
      isFile: function(e) {
        return "[object File]" === n.call(e);
      },
      isBlob: function(e) {
        return "[object Blob]" === n.call(e);
      },
      isFunction: s,
      isStream: function(e) {
        return a(e) && s(e.pipe);
      },
      isURLSearchParams: function(e) {
        return (
          "undefined" != typeof URLSearchParams && e instanceof URLSearchParams
        );
      },
      isStandardBrowserEnv: function() {
        return (
          ("undefined" == typeof navigator ||
            "ReactNative" !== navigator.product) &&
          "undefined" != typeof window &&
          "undefined" != typeof document
        );
      },
      forEach: c,
      merge: function r() {
        var n = {};
        function e(e, t) {
          "object" == typeof n[t] && "object" == typeof e
            ? (n[t] = r(n[t], e))
            : (n[t] = e);
        }
        for (var t = 0, o = arguments.length; t < o; t++) c(arguments[t], e);
        return n;
      },
      extend: function(r, e, n) {
        return (
          c(e, function(e, t) {
            r[t] = n && "function" == typeof e ? o(e, n) : e;
          }),
          r
        );
      },
      trim: function(e) {
        return e.replace(/^\s*/, "").replace(/\s*$/, "");
      },
    };
  },
  function(e, t, r) {
    e.exports = r(13);
  },
  function(e, t, r) {
    e.exports = r(14);
  },
  function(s, e, c) {
    "use strict";
    !function(e) {
      var r = c(1),
        n = c(18),
        t = { "Content-Type": "application/x-www-form-urlencoded" };
      function o(e, t) {
        !r.isUndefined(e) &&
          r.isUndefined(e["Content-Type"]) &&
          (e["Content-Type"] = t);
      }
      var i,
        a = {
          adapter: (i =
            "undefined" != typeof XMLHttpRequest || void 0 !== e ? c(6) : i),
          transformRequest: [
            function(e, t) {
              return (
                n(t, "Content-Type"),
                r.isFormData(e) ||
                r.isArrayBuffer(e) ||
                r.isBuffer(e) ||
                r.isStream(e) ||
                r.isFile(e) ||
                r.isBlob(e)
                  ? e
                  : r.isArrayBufferView(e)
                  ? e.buffer
                  : r.isURLSearchParams(e)
                  ? (o(t, "application/x-www-form-urlencoded;charset=utf-8"),
                    e.toString())
                  : r.isObject(e)
                  ? (o(t, "application/json;charset=utf-8"), JSON.stringify(e))
                  : e
              );
            },
          ],
          transformResponse: [
            function(e) {
              if ("string" == typeof e)
                try {
                  e = JSON.parse(e);
                } catch (e) {}
              return e;
            },
          ],
          timeout: 0,
          xsrfCookieName: "XSRF-TOKEN",
          xsrfHeaderName: "X-XSRF-TOKEN",
          maxContentLength: -1,
          validateStatus: function(e) {
            return 200 <= e && e < 300;
          },
          headers: { common: { Accept: "application/json, text/plain, */*" } },
        };
      r.forEach(["delete", "get", "head"], function(e) {
        a.headers[e] = {};
      }),
        r.forEach(["post", "put", "patch"], function(e) {
          a.headers[e] = r.merge(t);
        }),
        (s.exports = a);
    }.call(this, c(17));
  },
  function(e, t, r) {
    "use strict";
    e.exports = function(r, n) {
      return function() {
        for (var e = new Array(arguments.length), t = 0; t < e.length; t++)
          e[t] = arguments[t];
        return r.apply(n, e);
      };
    };
  },
  function(e, t, l) {
    "use strict";
    var f = l(1),
      p = l(19),
      d = l(8),
      h = l(21),
      g = l(22),
      m = l(7),
      y =
        ("undefined" != typeof window &&
          window.btoa &&
          window.btoa.bind(window)) ||
        l(23);
    e.exports = function(u) {
      return new Promise(function(t, r) {
        var n = u.data,
          o = u.headers;
        f.isFormData(n) && delete o["Content-Type"];
        var e,
          i,
          a = new XMLHttpRequest(),
          s = "onreadystatechange",
          c = !1;
        if (
          ("undefined" == typeof window ||
            !window.XDomainRequest ||
            "withCredentials" in a ||
            g(u.url) ||
            ((a = new window.XDomainRequest()),
            (s = "onload"),
            (c = !0),
            (a.onprogress = function() {}),
            (a.ontimeout = function() {})),
          u.auth &&
            ((e = u.auth.username || ""),
            (i = u.auth.password || ""),
            (o.Authorization = "Basic " + y(e + ":" + i))),
          a.open(
            u.method.toUpperCase(),
            d(u.url, u.params, u.paramsSerializer),
            !0
          ),
          (a.timeout = u.timeout),
          (a[s] = function() {
            var e;
            a &&
              (4 === a.readyState || c) &&
              (0 !== a.status ||
                (a.responseURL && 0 === a.responseURL.indexOf("file:"))) &&
              ((e =
                "getAllResponseHeaders" in a
                  ? h(a.getAllResponseHeaders())
                  : null),
              (e = {
                data:
                  u.responseType && "text" !== u.responseType
                    ? a.response
                    : a.responseText,
                status: 1223 === a.status ? 204 : a.status,
                statusText: 1223 === a.status ? "No Content" : a.statusText,
                headers: e,
                config: u,
                request: a,
              }),
              p(t, r, e),
              (a = null));
          }),
          (a.onerror = function() {
            r(m("Network Error", u, null, a)), (a = null);
          }),
          (a.ontimeout = function() {
            r(
              m("timeout of " + u.timeout + "ms exceeded", u, "ECONNABORTED", a)
            ),
              (a = null);
          }),
          f.isStandardBrowserEnv() &&
            ((s = l(24)),
            (s =
              (u.withCredentials || g(u.url)) && u.xsrfCookieName
                ? s.read(u.xsrfCookieName)
                : void 0) && (o[u.xsrfHeaderName] = s)),
          "setRequestHeader" in a &&
            f.forEach(o, function(e, t) {
              void 0 === n && "content-type" === t.toLowerCase()
                ? delete o[t]
                : a.setRequestHeader(t, e);
            }),
          u.withCredentials && (a.withCredentials = !0),
          u.responseType)
        )
          try {
            a.responseType = u.responseType;
          } catch (e) {
            if ("json" !== u.responseType) throw e;
          }
        "function" == typeof u.onDownloadProgress &&
          a.addEventListener("progress", u.onDownloadProgress),
          "function" == typeof u.onUploadProgress &&
            a.upload &&
            a.upload.addEventListener("progress", u.onUploadProgress),
          u.cancelToken &&
            u.cancelToken.promise.then(function(e) {
              a && (a.abort(), r(e), (a = null));
            }),
          a.send((n = void 0 === n ? null : n));
      });
    };
  },
  function(e, t, r) {
    "use strict";
    var i = r(20);
    e.exports = function(e, t, r, n, o) {
      e = new Error(e);
      return i(e, t, r, n, o);
    };
  },
  function(e, t, r) {
    "use strict";
    var o = r(1);
    function i(e) {
      return encodeURIComponent(e)
        .replace(/%40/gi, "@")
        .replace(/%3A/gi, ":")
        .replace(/%24/g, "$")
        .replace(/%2C/gi, ",")
        .replace(/%20/g, "+")
        .replace(/%5B/gi, "[")
        .replace(/%5D/gi, "]");
    }
    e.exports = function(e, t, r) {
      if (!t) return e;
      var n,
        t = r
          ? r(t)
          : o.isURLSearchParams(t)
          ? t.toString()
          : ((n = []),
            o.forEach(t, function(e, t) {
              null != e &&
                (o.isArray(e) && (t += "[]"),
                o.isArray(e) || (e = [e]),
                o.forEach(e, function(e) {
                  o.isDate(e)
                    ? (e = e.toISOString())
                    : o.isObject(e) && (e = JSON.stringify(e)),
                    n.push(i(t) + "=" + i(e));
                }));
            }),
            n.join("&"));
      return t && (e += (-1 === e.indexOf("?") ? "?" : "&") + t), e;
    };
  },
  function(e, t, r) {
    "use strict";
    e.exports = function(e) {
      return !(!e || !e.__CANCEL__);
    };
  },
  function(e, t, r) {
    "use strict";
    function n(e) {
      this.message = e;
    }
    (n.prototype.toString = function() {
      return "Cancel" + (this.message ? ": " + this.message : "");
    }),
      (n.prototype.__CANCEL__ = !0),
      (e.exports = n);
  },
  function(e, t) {
    t.TIMING_KEYS = [
      "",
      "fetchStart",
      "domainLookupStart",
      "domainLookupEnd",
      "connectStart",
      "connectEnd",
      "requestStart",
      "responseStart",
      "responseEnd",
      "",
      "domInteractive",
      "",
      "domContentLoadedEventEnd",
      "",
      "loadEventStart",
      "",
      "msFirstPaint",
      "secureConnectionStart",
    ];
  },
  function(e, t, r) {
    var n, o;
    /*!
     * JavaScript Cookie v2.2.1
     * https://github.com/js-cookie/js-cookie
     *
     * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
     * Released under the MIT license
     */ void 0 ===
      (n =
        "function" ==
        typeof (n = o = function() {
          function s() {
            for (var e = 0, t = {}; e < arguments.length; e++) {
              var r,
                n = arguments[e];
              for (r in n) t[r] = n[r];
            }
            return t;
          }
          function u(e) {
            return e.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
          }
          return (function e(c) {
            function a() {}
            function r(e, t, r) {
              if ("undefined" != typeof document) {
                "number" ==
                  typeof (r = s({ path: "/" }, a.defaults, r)).expires &&
                  (r.expires = new Date(+new Date() + 864e5 * r.expires)),
                  (r.expires = r.expires ? r.expires.toUTCString() : "");
                try {
                  var n = JSON.stringify(t);
                  /^[\{\[]/.test(n) && (t = n);
                } catch (e) {}
                (t = c.write
                  ? c.write(t, e)
                  : encodeURIComponent(String(t)).replace(
                      /%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,
                      decodeURIComponent
                    )),
                  (e = encodeURIComponent(String(e))
                    .replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
                    .replace(/[\(\)]/g, escape));
                var o,
                  i = "";
                for (o in r)
                  r[o] &&
                    ((i += "; " + o),
                    !0 !== r[o] && (i += "=" + r[o].split(";")[0]));
                return (document.cookie = e + "=" + t + i);
              }
            }
            function t(e, t) {
              if ("undefined" != typeof document) {
                for (
                  var r = {},
                    n = document.cookie ? document.cookie.split("; ") : [],
                    o = 0;
                  o < n.length;
                  o++
                ) {
                  var i = n[o].split("="),
                    a = i.slice(1).join("=");
                  t || '"' !== a.charAt(0) || (a = a.slice(1, -1));
                  try {
                    var s = u(i[0]),
                      a = (c.read || c)(a, s) || u(a);
                    if (t)
                      try {
                        a = JSON.parse(a);
                      } catch (e) {}
                    if (((r[s] = a), e === s)) break;
                  } catch (e) {}
                }
                return e ? r[e] : r;
              }
            }
            return (
              (a.set = r),
              (a.get = function(e) {
                return t(e, !1);
              }),
              (a.getJSON = function(e) {
                return t(e, !0);
              }),
              (a.remove = function(e, t) {
                r(e, "", s(t, { expires: -1 }));
              }),
              (a.defaults = {}),
              (a.withConverter = e),
              a
            );
          })(function() {});
        })
          ? n.call(t, r, t, e)
          : n) || (e.exports = n),
      (e.exports = o());
  },
  function(t, e, r) {
    t = (function(a) {
      "use strict";
      var c,
        e = Object.prototype,
        u = e.hasOwnProperty,
        t = "function" == typeof Symbol ? Symbol : {},
        n = t.iterator || "@@iterator",
        r = t.asyncIterator || "@@asyncIterator",
        o = t.toStringTag || "@@toStringTag";
      function i(e, t, r) {
        return (
          Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          }),
          e[t]
        );
      }
      try {
        i({}, "");
      } catch (e) {
        i = function(e, t, r) {
          return (e[t] = r);
        };
      }
      function s(e, t, r, n) {
        var o,
          i,
          a,
          s,
          t = t && t.prototype instanceof m ? t : m,
          t = Object.create(t.prototype),
          n = new k(n || []);
        return (
          (t._invoke =
            ((o = e),
            (i = r),
            (a = n),
            (s = f),
            function(e, t) {
              if (s === d) throw new Error("Generator is already running");
              if (s === h) {
                if ("throw" === e) throw t;
                return _();
              }
              for (a.method = e, a.arg = t; ; ) {
                var r = a.delegate;
                if (r) {
                  var n = (function e(t, r) {
                    var n = t.iterator[r.method];
                    if (n === c) {
                      if (((r.delegate = null), "throw" === r.method)) {
                        if (
                          t.iterator.return &&
                          ((r.method = "return"),
                          (r.arg = c),
                          e(t, r),
                          "throw" === r.method)
                        )
                          return g;
                        (r.method = "throw"),
                          (r.arg = new TypeError(
                            "The iterator does not provide a 'throw' method"
                          ));
                      }
                      return g;
                    }
                    n = l(n, t.iterator, r.arg);
                    if ("throw" === n.type)
                      return (
                        (r.method = "throw"),
                        (r.arg = n.arg),
                        (r.delegate = null),
                        g
                      );
                    var n = n.arg;
                    if (!n)
                      return (
                        (r.method = "throw"),
                        (r.arg = new TypeError(
                          "iterator result is not an object"
                        )),
                        (r.delegate = null),
                        g
                      );
                    {
                      if (!n.done) return n;
                      (r[t.resultName] = n.value),
                        (r.next = t.nextLoc),
                        "return" !== r.method &&
                          ((r.method = "next"), (r.arg = c));
                    }
                    r.delegate = null;
                    return g;
                  })(r, a);
                  if (n) {
                    if (n === g) continue;
                    return n;
                  }
                }
                if ("next" === a.method) a.sent = a._sent = a.arg;
                else if ("throw" === a.method) {
                  if (s === f) throw ((s = h), a.arg);
                  a.dispatchException(a.arg);
                } else "return" === a.method && a.abrupt("return", a.arg);
                s = d;
                n = l(o, i, a);
                if ("normal" === n.type) {
                  if (((s = a.done ? h : p), n.arg !== g))
                    return { value: n.arg, done: a.done };
                } else
                  "throw" === n.type &&
                    ((s = h), (a.method = "throw"), (a.arg = n.arg));
              }
            })),
          t
        );
      }
      function l(e, t, r) {
        try {
          return { type: "normal", arg: e.call(t, r) };
        } catch (e) {
          return { type: "throw", arg: e };
        }
      }
      a.wrap = s;
      var f = "suspendedStart",
        p = "suspendedYield",
        d = "executing",
        h = "completed",
        g = {};
      function m() {}
      function y() {}
      function v() {}
      var w = {};
      w[n] = function() {
        return this;
      };
      (t = Object.getPrototypeOf), (t = t && t(t(T([]))));
      t && t !== e && u.call(t, n) && (w = t);
      var b = (v.prototype = m.prototype = Object.create(w));
      function S(e) {
        ["next", "throw", "return"].forEach(function(t) {
          i(e, t, function(e) {
            return this._invoke(t, e);
          });
        });
      }
      function E(a, s) {
        var t;
        this._invoke = function(r, n) {
          function e() {
            return new s(function(e, t) {
              !(function t(e, r, n, o) {
                e = l(a[e], a, r);
                if ("throw" !== e.type) {
                  var i = e.arg,
                    r = i.value;
                  return r && "object" == typeof r && u.call(r, "__await")
                    ? s.resolve(r.__await).then(
                        function(e) {
                          t("next", e, n, o);
                        },
                        function(e) {
                          t("throw", e, n, o);
                        }
                      )
                    : s.resolve(r).then(
                        function(e) {
                          (i.value = e), n(i);
                        },
                        function(e) {
                          return t("throw", e, n, o);
                        }
                      );
                }
                o(e.arg);
              })(r, n, e, t);
            });
          }
          return (t = t ? t.then(e, e) : e());
        };
      }
      function C(e) {
        var t = { tryLoc: e[0] };
        1 in e && (t.catchLoc = e[1]),
          2 in e && ((t.finallyLoc = e[2]), (t.afterLoc = e[3])),
          this.tryEntries.push(t);
      }
      function x(e) {
        var t = e.completion || {};
        (t.type = "normal"), delete t.arg, (e.completion = t);
      }
      function k(e) {
        (this.tryEntries = [{ tryLoc: "root" }]),
          e.forEach(C, this),
          this.reset(!0);
      }
      function T(t) {
        if (t) {
          var e = t[n];
          if (e) return e.call(t);
          if ("function" == typeof t.next) return t;
          if (!isNaN(t.length)) {
            var r = -1,
              e = function e() {
                for (; ++r < t.length; )
                  if (u.call(t, r)) return (e.value = t[r]), (e.done = !1), e;
                return (e.value = c), (e.done = !0), e;
              };
            return (e.next = e);
          }
        }
        return { next: _ };
      }
      function _() {
        return { value: c, done: !0 };
      }
      return (
        (((y.prototype = b.constructor = v).constructor = y).displayName = i(
          v,
          o,
          "GeneratorFunction"
        )),
        (a.isGeneratorFunction = function(e) {
          e = "function" == typeof e && e.constructor;
          return (
            !!e &&
            (e === y || "GeneratorFunction" === (e.displayName || e.name))
          );
        }),
        (a.mark = function(e) {
          return (
            Object.setPrototypeOf
              ? Object.setPrototypeOf(e, v)
              : ((e.__proto__ = v), i(e, o, "GeneratorFunction")),
            (e.prototype = Object.create(b)),
            e
          );
        }),
        (a.awrap = function(e) {
          return { __await: e };
        }),
        S(E.prototype),
        (E.prototype[r] = function() {
          return this;
        }),
        (a.AsyncIterator = E),
        (a.async = function(e, t, r, n, o) {
          void 0 === o && (o = Promise);
          var i = new E(s(e, t, r, n), o);
          return a.isGeneratorFunction(t)
            ? i
            : i.next().then(function(e) {
                return e.done ? e.value : i.next();
              });
        }),
        S(b),
        i(b, o, "Generator"),
        (b[n] = function() {
          return this;
        }),
        (b.toString = function() {
          return "[object Generator]";
        }),
        (a.keys = function(r) {
          var e,
            n = [];
          for (e in r) n.push(e);
          return (
            n.reverse(),
            function e() {
              for (; n.length; ) {
                var t = n.pop();
                if (t in r) return (e.value = t), (e.done = !1), e;
              }
              return (e.done = !0), e;
            }
          );
        }),
        (a.values = T),
        (k.prototype = {
          constructor: k,
          reset: function(e) {
            if (
              ((this.prev = 0),
              (this.next = 0),
              (this.sent = this._sent = c),
              (this.done = !1),
              (this.delegate = null),
              (this.method = "next"),
              (this.arg = c),
              this.tryEntries.forEach(x),
              !e)
            )
              for (var t in this)
                "t" === t.charAt(0) &&
                  u.call(this, t) &&
                  !isNaN(+t.slice(1)) &&
                  (this[t] = c);
          },
          stop: function() {
            this.done = !0;
            var e = this.tryEntries[0].completion;
            if ("throw" === e.type) throw e.arg;
            return this.rval;
          },
          dispatchException: function(r) {
            if (this.done) throw r;
            var n = this;
            function e(e, t) {
              return (
                (i.type = "throw"),
                (i.arg = r),
                (n.next = e),
                t && ((n.method = "next"), (n.arg = c)),
                !!t
              );
            }
            for (var t = this.tryEntries.length - 1; 0 <= t; --t) {
              var o = this.tryEntries[t],
                i = o.completion;
              if ("root" === o.tryLoc) return e("end");
              if (o.tryLoc <= this.prev) {
                var a = u.call(o, "catchLoc"),
                  s = u.call(o, "finallyLoc");
                if (a && s) {
                  if (this.prev < o.catchLoc) return e(o.catchLoc, !0);
                  if (this.prev < o.finallyLoc) return e(o.finallyLoc);
                } else if (a) {
                  if (this.prev < o.catchLoc) return e(o.catchLoc, !0);
                } else {
                  if (!s)
                    throw new Error("try statement without catch or finally");
                  if (this.prev < o.finallyLoc) return e(o.finallyLoc);
                }
              }
            }
          },
          abrupt: function(e, t) {
            for (var r = this.tryEntries.length - 1; 0 <= r; --r) {
              var n = this.tryEntries[r];
              if (
                n.tryLoc <= this.prev &&
                u.call(n, "finallyLoc") &&
                this.prev < n.finallyLoc
              ) {
                var o = n;
                break;
              }
            }
            var i = (o =
              o &&
              ("break" === e || "continue" === e) &&
              o.tryLoc <= t &&
              t <= o.finallyLoc
                ? null
                : o)
              ? o.completion
              : {};
            return (
              (i.type = e),
              (i.arg = t),
              o
                ? ((this.method = "next"), (this.next = o.finallyLoc), g)
                : this.complete(i)
            );
          },
          complete: function(e, t) {
            if ("throw" === e.type) throw e.arg;
            return (
              "break" === e.type || "continue" === e.type
                ? (this.next = e.arg)
                : "return" === e.type
                ? ((this.rval = this.arg = e.arg),
                  (this.method = "return"),
                  (this.next = "end"))
                : "normal" === e.type && t && (this.next = t),
              g
            );
          },
          finish: function(e) {
            for (var t = this.tryEntries.length - 1; 0 <= t; --t) {
              var r = this.tryEntries[t];
              if (r.finallyLoc === e)
                return this.complete(r.completion, r.afterLoc), x(r), g;
            }
          },
          catch: function(e) {
            for (var t = this.tryEntries.length - 1; 0 <= t; --t) {
              var r = this.tryEntries[t];
              if (r.tryLoc === e) {
                var n,
                  o = r.completion;
                return "throw" === o.type && ((n = o.arg), x(r)), n;
              }
            }
            throw new Error("illegal catch attempt");
          },
          delegateYield: function(e, t, r) {
            return (
              (this.delegate = { iterator: T(e), resultName: t, nextLoc: r }),
              "next" === this.method && (this.arg = c),
              g
            );
          },
        }),
        a
      );
    })(t.exports);
    try {
      regeneratorRuntime = t;
    } catch (e) {
      Function("r", "regeneratorRuntime = r")(t);
    }
  },
  function(e, t, r) {
    "use strict";
    var n = r(1),
      o = r(5),
      i = r(16),
      a = r(4);
    function s(e) {
      var t = new i(e),
        e = o(i.prototype.request, t);
      return n.extend(e, i.prototype, t), n.extend(e, t), e;
    }
    var c = s(a);
    (c.Axios = i),
      (c.create = function(e) {
        return s(n.merge(a, e));
      }),
      (c.Cancel = r(10)),
      (c.CancelToken = r(31)),
      (c.isCancel = r(9)),
      (c.all = function(e) {
        return Promise.all(e);
      }),
      (c.spread = r(32)),
      (e.exports = c),
      (e.exports.default = c);
  },
  function(e, t) {
    function r(e) {
      return (
        !!e.constructor &&
        "function" == typeof e.constructor.isBuffer &&
        e.constructor.isBuffer(e)
      );
    }
    /*!
     * Determine if an object is a Buffer
     *
     * @author   Feross Aboukhadijeh <https://feross.org>
     * @license  MIT
     */
    e.exports = function(e) {
      return (
        null != e &&
        (r(e) ||
          ("function" == typeof (t = e).readFloatLE &&
            "function" == typeof t.slice &&
            r(t.slice(0, 0))) ||
          !!e._isBuffer)
      );
      var t;
    };
  },
  function(e, t, r) {
    "use strict";
    var n = r(4),
      o = r(1),
      i = r(25),
      a = r(26);
    function s(e) {
      (this.defaults = e),
        (this.interceptors = { request: new i(), response: new i() });
    }
    (s.prototype.request = function(e) {
      "string" == typeof e &&
        (e = o.merge({ url: arguments[0] }, arguments[1])),
        ((e = o.merge(
          n,
          this.defaults,
          { method: "get" },
          e
        )).method = e.method.toLowerCase());
      var t = [void 0],
        r = Promise.resolve(e);
      for (
        t.unshift(a),
          this.interceptors.request.forEach(function(e) {
            t.unshift(e.fulfilled, e.rejected);
          }),
          this.interceptors.response.forEach(function(e) {
            t.push(e.fulfilled, e.rejected);
          });
        t.length;

      )
        r = r.then(t.shift(), t.shift());
      return r;
    }),
      o.forEach(["delete", "get", "head", "options", "jsonp"], function(r) {
        s.prototype[r] = function(e, t) {
          return this.request(o.merge(t || {}, { method: r, url: e }));
        };
      }),
      o.forEach(["post", "put", "patch"], function(n) {
        s.prototype[n] = function(e, t, r) {
          return this.request(o.merge(r || {}, { method: n, url: e, data: t }));
        };
      }),
      (e.exports = s);
  },
  function(e, t) {
    var r,
      n,
      e = (e.exports = {});
    function o() {
      throw new Error("setTimeout has not been defined");
    }
    function i() {
      throw new Error("clearTimeout has not been defined");
    }
    function a(t) {
      if (r === setTimeout) return setTimeout(t, 0);
      if ((r === o || !r) && setTimeout)
        return (r = setTimeout), setTimeout(t, 0);
      try {
        return r(t, 0);
      } catch (e) {
        try {
          return r.call(null, t, 0);
        } catch (e) {
          return r.call(this, t, 0);
        }
      }
    }
    !(function() {
      try {
        r = "function" == typeof setTimeout ? setTimeout : o;
      } catch (e) {
        r = o;
      }
      try {
        n = "function" == typeof clearTimeout ? clearTimeout : i;
      } catch (e) {
        n = i;
      }
    })();
    var s,
      c = [],
      u = !1,
      l = -1;
    function f() {
      u &&
        s &&
        ((u = !1), s.length ? (c = s.concat(c)) : (l = -1), c.length && p());
    }
    function p() {
      if (!u) {
        var e = a(f);
        u = !0;
        for (var t = c.length; t; ) {
          for (s = c, c = []; ++l < t; ) s && s[l].run();
          (l = -1), (t = c.length);
        }
        (s = null),
          (u = !1),
          (function(t) {
            if (n === clearTimeout) return clearTimeout(t);
            if ((n === i || !n) && clearTimeout)
              return (n = clearTimeout), clearTimeout(t);
            try {
              n(t);
            } catch (e) {
              try {
                return n.call(null, t);
              } catch (e) {
                return n.call(this, t);
              }
            }
          })(e);
      }
    }
    function d(e, t) {
      (this.fun = e), (this.array = t);
    }
    function h() {}
    (e.nextTick = function(e) {
      var t = new Array(arguments.length - 1);
      if (1 < arguments.length)
        for (var r = 1; r < arguments.length; r++) t[r - 1] = arguments[r];
      c.push(new d(e, t)), 1 !== c.length || u || a(p);
    }),
      (d.prototype.run = function() {
        this.fun.apply(null, this.array);
      }),
      (e.title = "browser"),
      (e.browser = !0),
      (e.env = {}),
      (e.argv = []),
      (e.version = ""),
      (e.versions = {}),
      (e.on = h),
      (e.addListener = h),
      (e.once = h),
      (e.off = h),
      (e.removeListener = h),
      (e.removeAllListeners = h),
      (e.emit = h),
      (e.prependListener = h),
      (e.prependOnceListener = h),
      (e.listeners = function(e) {
        return [];
      }),
      (e.binding = function(e) {
        throw new Error("process.binding is not supported");
      }),
      (e.cwd = function() {
        return "/";
      }),
      (e.chdir = function(e) {
        throw new Error("process.chdir is not supported");
      }),
      (e.umask = function() {
        return 0;
      });
  },
  function(e, t, r) {
    "use strict";
    var o = r(1);
    e.exports = function(r, n) {
      o.forEach(r, function(e, t) {
        t !== n &&
          t.toUpperCase() === n.toUpperCase() &&
          ((r[n] = e), delete r[t]);
      });
    };
  },
  function(e, t, r) {
    "use strict";
    var o = r(7);
    e.exports = function(e, t, r) {
      var n = r.config.validateStatus;
      r.status && n && !n(r.status)
        ? t(
            o(
              "Request failed with status code " + r.status,
              r.config,
              null,
              r.request,
              r
            )
          )
        : e(r);
    };
  },
  function(e, t, r) {
    "use strict";
    e.exports = function(e, t, r, n, o) {
      return (
        (e.config = t), r && (e.code = r), (e.request = n), (e.response = o), e
      );
    };
  },
  function(e, t, r) {
    "use strict";
    var o = r(1),
      i = [
        "age",
        "authorization",
        "content-length",
        "content-type",
        "etag",
        "expires",
        "from",
        "host",
        "if-modified-since",
        "if-unmodified-since",
        "last-modified",
        "location",
        "max-forwards",
        "proxy-authorization",
        "referer",
        "retry-after",
        "user-agent",
      ];
    e.exports = function(e) {
      var t,
        r,
        n = {};
      return (
        e &&
          o.forEach(e.split("\n"), function(e) {
            (r = e.indexOf(":")),
              (t = o.trim(e.substr(0, r)).toLowerCase()),
              (r = o.trim(e.substr(r + 1))),
              t &&
                ((n[t] && 0 <= i.indexOf(t)) ||
                  (n[t] =
                    "set-cookie" === t
                      ? (n[t] || []).concat([r])
                      : n[t]
                      ? n[t] + ", " + r
                      : r));
          }),
        n
      );
    };
  },
  function(e, t, r) {
    "use strict";
    var n,
      o,
      i,
      a = r(1);
    function s(e) {
      return (
        o && (i.setAttribute("href", e), (e = i.href)),
        i.setAttribute("href", e),
        {
          href: i.href,
          protocol: i.protocol ? i.protocol.replace(/:$/, "") : "",
          host: i.host,
          search: i.search ? i.search.replace(/^\?/, "") : "",
          hash: i.hash ? i.hash.replace(/^#/, "") : "",
          hostname: i.hostname,
          port: i.port,
          pathname:
            "/" === i.pathname.charAt(0) ? i.pathname : "/" + i.pathname,
        }
      );
    }
    e.exports = a.isStandardBrowserEnv()
      ? ((o = /(msie|trident)/i.test(navigator.userAgent)),
        (i = document.createElement("a")),
        (n = s(window.location.href)),
        function(e) {
          e = a.isString(e) ? s(e) : e;
          return e.protocol === n.protocol && e.host === n.host;
        })
      : function() {
          return !0;
        };
  },
  function(e, t, r) {
    "use strict";
    function s() {
      this.message = "String contains an invalid character";
    }
    ((s.prototype = new Error()).code = 5),
      (s.prototype.name = "InvalidCharacterError"),
      (e.exports = function(e) {
        for (
          var t,
            r,
            n = String(e),
            o = "",
            i = 0,
            a =
              "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
          n.charAt(0 | i) || ((a = "="), i % 1);
          o += a.charAt(63 & (t >> (8 - (i % 1) * 8)))
        ) {
          if (255 < (r = n.charCodeAt((i += 0.75)))) throw new s();
          t = (t << 8) | r;
        }
        return o;
      });
  },
  function(e, t, r) {
    "use strict";
    var s = r(1);
    e.exports = s.isStandardBrowserEnv()
      ? {
          write: function(e, t, r, n, o, i) {
            var a = [];
            a.push(e + "=" + encodeURIComponent(t)),
              s.isNumber(r) && a.push("expires=" + new Date(r).toGMTString()),
              s.isString(n) && a.push("path=" + n),
              s.isString(o) && a.push("domain=" + o),
              !0 === i && a.push("secure"),
              (document.cookie = a.join("; "));
          },
          read: function(e) {
            e = document.cookie.match(
              new RegExp("(^|;\\s*)(" + e + ")=([^;]*)")
            );
            return e ? decodeURIComponent(e[3]) : null;
          },
          remove: function(e) {
            this.write(e, "", Date.now() - 864e5);
          },
        }
      : {
          write: function() {},
          read: function() {
            return null;
          },
          remove: function() {},
        };
  },
  function(e, t, r) {
    "use strict";
    var n = r(1);
    function o() {
      this.handlers = [];
    }
    (o.prototype.use = function(e, t) {
      return (
        this.handlers.push({ fulfilled: e, rejected: t }),
        this.handlers.length - 1
      );
    }),
      (o.prototype.eject = function(e) {
        this.handlers[e] && (this.handlers[e] = null);
      }),
      (o.prototype.forEach = function(t) {
        n.forEach(this.handlers, function(e) {
          null !== e && t(e);
        });
      }),
      (e.exports = o);
  },
  function(e, t, r) {
    "use strict";
    var n = r(1),
      o = r(27),
      i = r(9),
      a = r(4),
      s = r(28),
      c = r(29),
      u = r(30);
    function l(e) {
      e.cancelToken && e.cancelToken.throwIfRequested();
    }
    e.exports = function(t) {
      l(t),
        t.baseURL && !s(t.url) && (t.url = c(t.baseURL, t.url)),
        (t.headers = t.headers || {}),
        (t.data = o(t.data, t.headers, t.transformRequest)),
        (t.headers = n.merge(
          t.headers.common || {},
          t.headers[t.method] || {},
          t.headers || {}
        )),
        n.forEach(
          ["delete", "get", "head", "post", "put", "patch", "common"],
          function(e) {
            delete t.headers[e];
          }
        );
      var e = t.adapter || a.adapter;
      return "jsonp" === t.method
        ? u(t)
        : e(t).then(
            function(e) {
              return (
                l(t), (e.data = o(e.data, e.headers, t.transformResponse)), e
              );
            },
            function(e) {
              return (
                i(e) ||
                  (l(t),
                  e &&
                    e.response &&
                    (e.response.data = o(
                      e.response.data,
                      e.response.headers,
                      t.transformResponse
                    ))),
                Promise.reject(e)
              );
            }
          );
    };
  },
  function(e, t, r) {
    "use strict";
    var n = r(1);
    e.exports = function(t, r, e) {
      return (
        n.forEach(e, function(e) {
          t = e(t, r);
        }),
        t
      );
    };
  },
  function(e, t, r) {
    "use strict";
    e.exports = function(e) {
      return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(e);
    };
  },
  function(e, t, r) {
    "use strict";
    e.exports = function(e, t) {
      return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
    };
  },
  function(e, t, r) {
    "use strict";
    var p = r(8),
      d = 0;
    function h() {}
    e.exports = function(n) {
      var e,
        o,
        t = n.prefix || "__jp",
        i = n.callback || "callback",
        a = n.name || t + d++,
        s = n.timeout || 6e4,
        c = n.cache || !1,
        u = encodeURIComponent,
        l = document.getElementsByTagName("script")[0] || document.head;
      function f() {
        e.parentNode && e.parentNode.removeChild(e),
          (window[a] = h),
          o && clearTimeout(o);
      }
      if (!n.url) throw new TypeError("url is null or not defined");
      return new Promise(function(t, r) {
        try {
          s &&
            (o = setTimeout(function() {
              f(), r(new Error("Request timed out"));
            }, s)),
            (window[a] = function(e) {
              f(), n.cancelToken && n.cancelToken.throwIfRequested(), t(e);
            }),
            (n.url = p(n.url, n.params, n.paramsSerializer)),
            (n.url += (-1 === n.url.indexOf("?") ? "?" : "&") + i + "=" + u(a)),
            c || (n.url += "&_=" + new Date().getTime()),
            ((e = document.createElement("script")).src = n.url),
            l.parentNode.insertBefore(e, l);
        } catch (e) {
          r(e);
        }
      });
    };
  },
  function(e, t, r) {
    "use strict";
    var n = r(10);
    function o(e) {
      if ("function" != typeof e)
        throw new TypeError("executor must be a function.");
      var t;
      this.promise = new Promise(function(e) {
        t = e;
      });
      var r = this;
      e(function(e) {
        r.reason || ((r.reason = new n(e)), t(r.reason));
      });
    }
    (o.prototype.throwIfRequested = function() {
      if (this.reason) throw this.reason;
    }),
      (o.source = function() {
        var t;
        return {
          token: new o(function(e) {
            t = e;
          }),
          cancel: t,
        };
      }),
      (e.exports = o);
  },
  function(e, t, r) {
    "use strict";
    e.exports = function(t) {
      return function(e) {
        return t.apply(null, e);
      };
    };
  },
  function(e, t, r) {
    "use strict";
    function n(e, t) {
      e = o[a] = new i(e);
      e.sendPipe(t);
      t = e._conf;
      return (
        !1 !== t.autoSendPv && e.sendPV(),
        (t && t.useFmp) || e.sendPerformance(),
        t && t.sendResource && e.sendResources(),
        (o[s] = !0),
        e
      );
    }
    var o = window,
      i = (o.BrowserLogger = r(34)),
      a = r(0).key,
      s = "__hasInitBlSdk";
    (i.singleton = function(e, t) {
      return o[s] ? o[a] : n(e, t);
    }),
      (i.createExtraInstance = function(e) {
        e &&
          "object" == typeof e &&
          !0 !== e.enableInstanceAutoSend &&
          (e.enableInstanceAutoSend = !1);
        var t = new i(e),
          e = t._conf;
        return (
          e.enableInstanceAutoSend &&
            (!1 !== e.autoSendPv && t.sendPV(),
            (e && e.useFmp) || t.sendPerformance(),
            e && e.sendResource && t.sendResources()),
          t
        );
      }),
      "object" == typeof window &&
        !!window.navigator &&
        o[a] &&
        (i.bl = (function() {
          if (o[s]) return o[a];
          var e = {},
            t = [];
          return (
            a in o && ((e = o[a].config || {}), (t = o[a].pipe || [])), n(e, t)
          );
        })(o.__hasInitBlSdk)),
      (e.exports = i);
  },
  function(e, t, r) {
    function n(e) {
      var r = this;
      return (
        i.call(r, e),
        (r._initialPage =
          (e.page && o.safetyCall(e.page, [], e.page + "")) || null),
        (r._isRobot = o.isRobot()),
        (r._health = { errcount: 0, apisucc: 0, apifail: 0 }),
        !(r.beforeSend = function(e, t) {
          "error" === e
            ? r._health.errcount++
            : "api" === e && r._health[t.success ? "apisucc" : "apifail"]++;
        }) !== e.enableInstanceAutoSend &&
          (r.initHandler(),
          r.initHook(),
          r.initFmpObserver(1e4),
          r._conf &&
            r._conf.behavior &&
            "function" == typeof r.initBehavior &&
            r.initBehavior()),
        Object.defineProperty &&
          c.addEventListener &&
          Object.defineProperty(r, "pipe", { set: r.sendPipe }),
        r
      );
    }
    var o = r(0),
      i = r(35),
      a = r(38),
      s = r(39),
      c = o.win,
      u = c.document,
      l = /^(error|api|speed|sum|avg|percent|custom|msg|setPage|setConfig|behavior|performance)$/;
    (n.prototype = o.createObject(i.prototype)),
      o.ext(i._root.dftCon, {
        uid: null,
        setUsername: null,
        ignoreUrlPath: null,
        ignoreApiPath: null,
        urlHelper: [
          { rule: /\/([a-z\-_]+)?\d{2,20}/g, target: "/$1**" },
          /\/$/,
        ],
        apiHelper: { rule: /\/([a-z\-_]+)?\d{2,20}/g, target: "/$1**" },
        ignoreUrlCase: !0,
        imgUrl: "https://arms-retcode.aliyuncs.com/r.png?",
        disableHook: !1,
        autoSendPv: !0,
        autoSendPerf: !0,
        enableSPA: !1,
        enableLinkTrace: !1,
        linkType: "arms",
        enableApiCors: !1,
        sendResource: !0,
        behavior: !0,
        enableConsole: !1,
        parseHash: function(e) {
          return (e ? o.cutUrlSearch(e.replace(/^#\/?/, "")) : "") || "[index]";
        },
        parseResponse: function(e) {
          if (!e || "object" != typeof e) return {};
          var t = e.code,
            e =
              e.msg ||
              e.message ||
              e.subMsg ||
              e.errorMsg ||
              e.ret ||
              e.errorResponse ||
              "";
          return (
            "object" == typeof e &&
              ((t = t || e.code),
              (e = e.msg || e.message || e.info || e.ret || JSON.stringify(e))),
            { msg: e, code: t, success: !0 }
          );
        },
      }),
      o.ext(n.prototype, {
        constructor: n,
        _super: i,
        onReady: function(e) {
          var t = this;
          if (t.hasReady) return e();
          "complete" === u.readyState
            ? ((t.hasReady = !0), e())
            : o.on(
                c,
                "load",
                function() {
                  (t.hasReady = !0), e();
                },
                !0
              );
        },
        getPage: function(e) {
          var t = this._conf,
            r = t.page,
            n = location,
            n = n.host + n.pathname;
          return r && !e
            ? o.safetyCall(r, [], r + "")
            : this._initialPage ||
                o.filterByRule(
                  t.ignoreUrlCase ? n.toLowerCase() : n,
                  t.ignoreUrlPath || t.urlHelper
                );
        },
        setPage: function(e, t) {
          var r = this,
            n = r.prevPage;
          if (!1 !== t) {
            if (!e || e === n) return r;
            (r.prevPage = e),
              clearTimeout(r.sendPVTimmer),
              r.handleUnload(1),
              r.resetPageview(),
              (r.sendPVTimmer = setTimeout(function() {
                r.sendPV();
              }, 10));
          } else r.prevPage = e;
          return (r._conf.page = e), r;
        },
        setConfig: function(e, t) {
          var r;
          e &&
            "object" == typeof e &&
            (o.verifyConfig(e),
            (e = this.setImgUrl(e)),
            (r = this._conf),
            (this._conf = o.ext({}, r, e)),
            t ||
              ((t = "disableHook") in e &&
                r[t] !== e[t] &&
                (e[t] ? this.removeHook() : this.addHook()),
              (t = "enableSPA") in e &&
                r[t] !== e[t] &&
                this.bindHashChange(e[t])));
        },
        sendRequest: function(e) {
          a(e, this.getConfig("imgUrl"));
        },
        postData: function(e, t) {
          var r = {};
          (r[t] = e[t]), delete e[t];
          t = "";
          "object" == typeof e && (t = o.serialize(e)),
            s(r, this.getConfig("imgUrl") + t + "&post_res=");
        },
        sendPipe: function(e) {
          var t = this;
          if (!e || !e.length) return t;
          try {
            if ("Array" === o.T(e[0]))
              return o.each(e, function(e) {
                return t.sendPipe(e);
              });
            if ("Array" !== o.T(e)) return t;
            var r = e.shift();
            if (!l.test(r)) return t;
            t[r].apply(t, e);
          } catch (e) {
            return o.warn("[retcode] error in sendPipe", e), t;
          }
        },
        sendHealth: function() {
          var e = o.ext({}, this._health);
          (e.healthy = 0 < e.errcount ? 0 : 1), (e.begin = Date.now());
          var t = e.begin - this.sBegin;
          (e.stay = t),
            this._lg("health", e, 1),
            (this._health = { errcount: 0, apisucc: 0, apifail: 0 });
        },
        createInstance: function(e) {
          e = o.ext({ pid: this._conf.pid }, e);
          var t = this.__proto__.constructor(e);
          return e.page && t.sendPV(), t;
        },
      }),
      r(40)(n, c),
      r(41)(n, c, u),
      r(44)(n, c, u),
      r(45)(n, c),
      r(46)(n, c),
      (n._super = i),
      (n._root = i._root),
      (i.Browser = n),
      (e.exports = n);
  },
  function(e, t, r) {
    function o(e) {
      var t = (e.key || "default").split("::");
      return 1 < t.length
        ? p.ext(e, { group: t[0], key: t[1] })
        : p.ext(e, { group: "default_group", key: t[0] });
    }
    var p = r(0),
      n = r(36),
      d = [
        "api",
        "success",
        "time",
        "code",
        "msg",
        "trace",
        "traceId",
        "begin",
        "pv_id",
        "sid",
        "seq",
        "domain",
        "flag",
      ],
      r = function(e) {
        var t;
        n.call(this, e);
        try {
          t =
            "object" == typeof performance
              ? performance.timing.fetchStart
              : Date.now();
        } catch (e) {
          t = Date.now();
        }
        return (this._startTime = t), this;
      };
    (r.prototype = p.createObject(n.prototype)),
      p.ext(n.dftCon, { startTime: null }),
      p.ext(r.prototype, {
        constructor: r,
        _super: n,
        sum: function(e, t, r) {
          try {
            var n = p.dealParam(e, t, 1);
            return this._lg("sum", o(n), r);
          } catch (e) {
            p.warn("[retcode] can not get parseStatData: " + e);
          }
        },
        avg: function(e, t, r) {
          try {
            var n = p.dealParam(e, t, 0);
            return this._lg("avg", o(n), r);
          } catch (e) {
            p.warn("[retcode] can not get parseStatData: " + e);
          }
        },
        percent: function(e, t, r, n) {
          try {
            return this._lg(
              "percent",
              o({ key: e, subkey: t, val: r || 0, begin: Date.now() }),
              n
            );
          } catch (e) {
            p.warn("[retcode] can not get parseStatData: " + e);
          }
        },
        msg: function(e, t) {
          if (e && !(180 < e.length)) return this.custom({ msg: e }, t);
        },
        error: function(e, t) {
          if (!e) return p.warn("[retcode] invalid param e: " + e), this;
          1 === arguments.length
            ? ("string" == typeof e && ((e = { message: e }), (t = {})),
              "object" == typeof e && (t = e = e.error || e))
            : ("string" == typeof e && (e = { message: e }),
              "object" != typeof t && (t = {}));
          var r = e.name || "CustomError",
            n = e.message || "",
            o = e.stack || "";
          t = t || {};
          var i =
            ("object" == typeof location &&
              "string" == typeof location.href &&
              location.href.substring(0, 500)) ||
            "";
          if (p.checkSDKError(n, t.filename)) {
            var a = /^Script error\.?$/,
              s = e.msg || e.message;
            if (p.ignoreByRule(s, a) || p.ignoreByRule(p.decode(s), a))
              return this;
            a = {
              msg: p.selfErrKey,
              err: { msg_raw: p.encode(e.msg || e.message) },
            };
            return this._self("error", a, 1);
          }
          for (
            var c = {
                begin: Date.now(),
                cate: r,
                msg: n && n.substring(0, 1e3),
                stack: o && o.substring(0, 1e3),
                file: p.removeUrlSearch(t.filename || ""),
                line: t.lineno || "",
                col: t.colno || "",
                err: { msg_raw: p.encode(n), stack_raw: p.encode(o) },
                dl: i,
              },
              u = ["tag", "c1", "c2", "c3"],
              l = 0;
            l < u.length;
            l++
          ) {
            var f = u[l];
            t[f] && (c[f] = t[f]);
          }
          i = (this.getConfig("ignore") || {}).ignoreErrors;
          return p.ignoreByRule(c.msg, i) || p.ignoreByRule(p.decode(c.msg), i)
            ? this
            : (this.beforeSend && this.beforeSend("error", c),
              this._lg("error", c, 1));
        },
        behavior: function(e) {
          if (e) {
            e = "object" == typeof e && e.behavior ? e : { behavior: e };
            return (
              this.beforeSend && this.beforeSend("behavior", e),
              this._lg("behavior", e, 1)
            );
          }
        },
        api: function(e, t, r, n, o, i, a, s, c, u, l, f) {
          if (!e) return p.warn("[retcode] api is null"), this;
          if (
            ((e =
              "string" == typeof e
                ? {
                    api: e,
                    success: t,
                    time: r,
                    code: n,
                    msg: o,
                    begin: i,
                    traceId: a,
                    pv_id: s,
                    apiSnapshot: c,
                    domain: u,
                    flag: f,
                  }
                : p.sub(e, d)),
            !p.checkAPI(e.api, !0))
          )
            return this;
          e.code = e.code || "";
          f = "string" == typeof (f = e.msg || "") ? f.substring(0, 1e3) : f;
          if (
            ((e.msg = f),
            (e.success = e.success ? 1 : 0),
            (e.time = +e.time),
            (e.begin = e.begin),
            (e.traceId = e.traceId || ""),
            (e.pv_id = e.pv_id || ""),
            (e.domain = e.domain || ""),
            (e.flag = e.flag),
            (e.dl =
              ("object" == typeof location &&
                "string" == typeof location.href &&
                location.href.substring(0, 500)) ||
              ""),
            e.success
              ? e.apiSnapshot && delete e.apiSnapshot
              : (e.apiSnapshot = c),
            l && (e.traceOrigin = l),
            !e.api || isNaN(e.time))
          )
            return p.warn("[retcode] invalid time or api"), this;
          l = (this.getConfig("ignore") || {}).ignoreApis;
          return p.ignoreByRule(e.api, l) || p.ignoreByRule(p.decode(e.api), l)
            ? this
            : (this.beforeSend && this.beforeSend("api", e),
              this._lg(
                "api",
                e,
                e.success && this.getConfig("sample"),
                e.flag
              ));
        },
        speed: function(e, t, r) {
          var n = this,
            o = this.getConfig("startTime") || this._startTime;
          return (
            /^s(\d|1[0])$/.test(e)
              ? ((t =
                  "number" != typeof t ? Date.now() - o : o <= t ? t - o : t),
                (n.speedCache = n.speedCache || {}),
                (n.speedCache[e] = t),
                (n.speedCache.begin = o),
                clearTimeout(n.speedTimmer),
                (n.speedTimmer = setTimeout(function() {
                  r || (n.speedCache.page = n.getPage(!0)),
                    n._lg("speed", n.speedCache),
                    (n.speedCache = null);
                }, 5e3)))
              : p.warn("[retcode] invalid point: " + e),
            n
          );
        },
        performance: function(e) {
          if (e && "object" == typeof e && !this.hasSendPerf) {
            var t,
              r = {},
              n = {},
              o = this.getConfig("autoSendPerf");
            if (e.autoSend && o)
              return (
                (n = p.ext(this.perfData || {}, e)),
                (this.hasSendPerf = !0),
                this._lg("perf", n, this.getConfig("sample"))
              );
            if (e.autoSend && !o)
              return (
                delete e.autoSend,
                this.perfData
                  ? ((n = p.ext(this.perfData || {}, e)),
                    (this.hasSendPerf = !0),
                    this._lg("perf", n, this.getConfig("sample")))
                  : void (this.perfData = e)
              );
            for (t in e)
              (!/^t([1-9]|1[0])$/.test(t) && "ctti" !== t && "cfpt" !== t) ||
                (r[t] = e[t]);
            if (!0 === e.autoSend || (!o && (o || this.perfData)))
              return !0 !== e.autoSend && !1 === o && this.perfData
                ? ((r = p.ext(this.perfData || {}, r)),
                  (this.hasSendPerf = !0),
                  this._lg("perf", r, this.getConfig("sample")))
                : void 0;
            this.perfData = p.ext(this.perfData || {}, r);
          }
        },
        resource: function(e, t) {
          if (!e || !p.isPlainObject(e))
            return p.warn("[arms] invalid param data: " + e), this;
          var r,
            n = Object.keys(e),
            o = ["begin", "dom", "load", "res", "dl"],
            i = !1;
          for (r in o)
            if (n.indexOf(o[r]) < 0) {
              i = !0;
              break;
            }
          if (i) return p.warn("[arms] lack param data: " + e), this;
          e = {
            begin: e.begin || Date.now(),
            dom: e.dom || "",
            load: e.load || "",
            res: p.isArray(e.res) ? JSON.stringify(e.res) : JSON.stringify([]),
            dl: e.dl || "",
          };
          return this._lg("res", e, t);
        },
      }),
      (r._super = n),
      ((r._root = n).Reporter = r),
      (e.exports = r);
  },
  function(e, t, r) {
    function l(e, t) {
      var r, n, o;
      if (
        "error" !== t.t ||
        !(r = e.requestQueue[0]) ||
        "error" !== r.t ||
        t.msg !== r.msg
      )
        return (
          "behavior" === t.t
            ? 0 < (n = e.requestQueue && e.requestQueue.length) &&
              "behavior" === e.requestQueue[n - 1].t
              ? ((o = t.behavior || []),
                e.requestQueue[n - 1].behavior.concat(o))
              : e.requestQueue.push(t)
            : e.requestQueue.unshift(t),
          e.onReady(function() {
            e.requestTimmer = f.delay(
              function() {
                e.clear();
              },
              e.requestQueue[0] && "error" === e.requestQueue[0].t ? 3e3 : -1
            );
          }),
          !0
        );
      r.times++;
    }
    var f = r(0),
      n = r(37),
      i = "aokcdqn3ly@e629dabd48a9933",
      o = function(e) {
        return (
          (this.ver = "1.8.28"),
          (this._conf = f.ext({}, o.dftCon)),
          (this.sampleCache = {}),
          (this.requestQueue = []),
          (this.selfQueue = []),
          (this.sdkFlag = !0),
          (this.hash = f.seq()),
          this.resetPageview(),
          this.setConfig(e),
          (this.rip = f.getRandIP()),
          (this.record = 999),
          (this["EagleEye-TraceID"] = this.getTraceId()["EagleEye-TraceID"]),
          (this._common = {}),
          this
        );
      };
    (o.dftCon = {
      sample: 1,
      pvSample: 1,
      tag: "",
      imgUrl: "https://arms-retcode.aliyuncs.com/r.png?",
      region: null,
      ignore: {
        ignoreUrls: [],
        ignoreApis: [],
        ignoreErrors: [/^Script error\.?$/],
        ignoreResErrors: [],
      },
      release: void 0,
      environment: "prod",
    }),
      (o.prototype = {
        constructor: o,
        onReady: function(e) {
          return e();
        },
        getPage: function() {
          var e = this._conf.page;
          return f.safetyCall(e, [], e + "");
        },
        setPage: function() {},
        setConfig: function(e) {
          e &&
            "object" == typeof e &&
            (f.verifyConfig(e),
            (e = this.setImgUrl(e)),
            (this._conf = f.ext({}, this._conf, e)));
        },
        setImgUrl: function(e) {
          var t = e.region,
            r = e.imgUrl;
          if (t) {
            t = f.regionMap[t];
            return (e.imgUrl = t || f.defaultImgUrl), e;
          }
          return r && (e.imgUrl = r), e;
        },
        checkImgUrl: function(e) {
          if (this.getConfig("debug")) return !0;
          var t,
            r = f.regionMap,
            n = !1;
          for (t in r)
            if (r[t] === e) {
              n = !0;
              break;
            }
          return n || f.warn("[retcode] invalid url: " + e), n;
        },
        sendRequest: function() {},
        sendBeacon: function(e) {
          n(e, this.getConfig("imgUrl"));
        },
        postData: function() {},
        commonInfo: function() {
          return {};
        },
        setCommonInfo: function(e) {
          e &&
            "object" == typeof e &&
            (this._common = f.ext({}, this._common, e));
        },
        resetPageview: function() {
          (this.pageview = f.uu()), (this.sBegin = Date.now());
        },
        getUsername: function() {
          if (this.username) return this.username;
          var e = this._conf,
            e = e && e.setUsername;
          if ("function" == typeof e)
            try {
              var t = e();
              "string" == typeof t &&
                ((t = t.substr(0, 20)), (this.username = t));
            } catch (e) {
              f.warn("[arms] setUsername fail", e);
            }
          return this.username;
        },
        getTraceId: function() {
          var e = this.rip,
            t = Date.now(),
            r = f.getSortNum(this.record),
            t = e + t + r + f.getRandNum(this._conf.pid);
          return (
            (this["EagleEye-TraceID"] = t),
            (this.record = r),
            { "EagleEye-TraceID": t }
          );
        },
        getUberTraceId: function(e) {
          var t = this.rip,
            r = Date.now(),
            n = f.getSortNum(this.record),
            o = f.getRandNum(this._conf.pid),
            n = t + r + n + f.getNum(2) + o,
            o = n.substring(0, 16);
          return {
            "uber-trace-id": n + ":" + o + ":0:" + (e = e ? "1" : "0"),
            traceId: n,
          };
        },
        getPageviewId: function() {
          return { "EagleEye-SessionID": this.pageview };
        },
        getConfig: function(e) {
          return e ? this._conf[e] : f.ext({}, this._conf);
        },
        sampling: function(e) {
          return (
            1 === e ||
            ("boolean" == typeof this.sampleCache[e] ||
              (this.sampleCache[e] = f.pick(e)),
            this.sampleCache[e])
          );
        },
        clear: function(e) {
          var t;
          clearTimeout(this.requestTimmer), (this.requestTimmer = null);
          for (
            var r = this._conf && "function" == typeof this._conf.sendRequest;
            (t = this.requestQueue.pop());

          )
            "res" === t.t
              ? this.postData(t, "res")
              : "error" === t.t
              ? this.postData(t, "err")
              : "api" === t.t
              ? this.postData(t, "apiSnapshot")
              : "behavior" === t.t
              ? this.postData(t, "behavior")
              : "health" === t.t &&
                !r &&
                window &&
                window.navigator &&
                "function" == typeof window.navigator.sendBeacon
              ? this.sendBeacon(t)
              : this.sendRequest(t);
          return e && this.clearSelf(), this;
        },
        clearSelf: function() {
          var e;
          for (
            clearTimeout(this.Timmer), this.Timmer = null;
            (e = this.selfQueue.pop());

          )
            this.postData(e, "err");
          return this;
        },
        _lg: function(e, t, r, n) {
          var o = this._conf,
            i = this.getPage(),
            a = o.ignore || {},
            s = a.ignoreErrors,
            c = a.ignoreResErrors,
            u = a.ignoreUrls,
            a = a.ignoreApis;
          if (this._isRobot) return this;
          if (f.ignoreByRule(i, u) || f.ignoreByRule(f.decode(i), u))
            return this;
          if (
            "error" === e &&
            (f.ignoreByRule(t.msg, s) || f.ignoreByRule(f.decode(t.msg), s))
          )
            return this;
          if (
            "resourceError" === e &&
            (f.ignoreByRule(t.src, c) || f.ignoreByRule(f.decode(t.src), c))
          )
            return this;
          if (
            "api" === e &&
            (f.ignoreByRule(t.api, a) || f.ignoreByRule(f.decode(t.api), a))
          )
            return this;
          if (!this.checkImgUrl(o.imgUrl)) return this;
          if (!t || o.disabled || !o.pid) return this;
          if (0 === n) return this;
          a = t.dl;
          return (
            delete t.dl,
            (t = f.ext(
              {
                t: e,
                times: 1,
                page: i,
                tag: o.tag || "",
                release: o.release || "",
                environment: o.environment,
                begin: Date.now(),
                c1: o.c1,
                c2: o.c2,
                c3: o.c3,
              },
              t,
              this.commonInfo(),
              this._common,
              {
                pid: o.pid,
                _v: this.ver,
                pv_id: this.pageview,
                username: this.getUsername(),
                sampling: r || 1,
                dl: a,
                z: f.seq(),
              }
            )),
            1 !== n && r && !this.sampling(r) ? this : l(this, t)
          );
        },
        _self: function(e, t, r) {
          var n = this,
            o = n._conf;
          if ("error" !== e) return n;
          if (!n.checkImgUrl(o.imgUrl)) return n;
          if (!t || o.disabled || !o.pid) return n;
          if (r && !n.sampling(r)) return n;
          t = f.ext(
            {
              t: e,
              times: 1,
              page: f.selfErrPage,
              tag: o.pid,
              begin: Date.now(),
            },
            t,
            { pid: i, _v: n.ver, sampling: r || 1, z: f.seq() }
          );
          r = n.selfQueue[0];
          if (r) {
            r.times++;
            try {
              r.err &&
                t.err &&
                r.err.msg_raw &&
                t.err.msg_raw &&
                r.err.msg_raw.split("&").indexOf(t.err.msg_raw) < 0 &&
                r.err.msg_raw.length < 1e3 &&
                (r.err.msg_raw += "&" + t.err.msg_raw);
            } catch (e) {}
          } else
            n.selfQueue.unshift(t),
              n.onReady(function() {
                n.sdkFlag &&
                  ((n.sdkFlag = !1),
                  (n.Timmer = f.delay(function() {
                    n.clearSelf();
                  }, 1e4)));
              });
        },
        custom: function(e, t) {
          if (!e || "object" != typeof e) return this;
          var r = !1,
            n = { begin: Date.now() };
          return (
            f.each(e, function(e, t) {
              return (
                (r = t && t.length <= 20) ||
                  f.warn("[retcode] invalid key: " + t),
                (n["x-" + t] = e),
                r
              );
            }),
            r ? this._lg("custom", n, t || 1) : this
          );
        },
      }),
      (e.exports = o);
  },
  function(e, t, r) {
    var n = r(0);
    e.exports = function(e, t) {
      "object" == typeof e && (e = n.serialize(e)),
        window &&
        window.navigator &&
        "function" == typeof window.navigator.sendBeacon
          ? window.navigator.sendBeacon(t + e, "&post_res=")
          : n.warn("[arms] navigator.sendBeacon not surported");
    };
  },
  function(e, t, r) {
    var o = r(0),
      i = "object" == typeof window ? window : {},
      a = "function" == typeof (a = i.__oFetch_ || i.fetch) ? a : void 0;
    e.exports = function(e, t) {
      var r = -1;
      "object" == typeof e && ((r = e.z), (e = o.serialize(e)));
      var n,
        e = t + e;
      if (a) return a(e, { method: "HEAD", mode: "no-cors" }).catch(o.noop);
      i.document &&
        i.document.createElement &&
        (((r = i[
          (n = "__request_hold_" + r)
        ] = new Image()).onload = r.onerror = function() {
          i[n] = void 0;
        }),
        (r.src = e),
        (r = null));
    };
  },
  function(e, t, r) {
    var n = r(0),
      r = "object" == typeof window ? window : {},
      o =
        "function" == typeof (o = r.__oXMLHttpRequest_ || r.XMLHttpRequest)
          ? o
          : void 0;
    e.exports = function(e, t) {
      try {
        var r = new o();
        r.open("POST", t, !0),
          r.setRequestHeader("Content-Type", "text/plain"),
          r.send(JSON.stringify(e));
      } catch (e) {
        n.warn("[retcode] Failed to log, exception is :\n" + e);
      }
    };
  },
  function(e, t, r) {
    var p = r(0);
    e.exports = function(e, s) {
      function a(e, t, r) {
        var n;
        null !== e && ((n = e[t]), (e[t] = r(n)));
      }
      function c(r, n) {
        return function(e) {
          if (e && e !== f) {
            var a, t;
            f = e;
            try {
              a = e.target;
            } catch (e) {
              a = "<unknown>";
            }
            0 !== a.length &&
              ((t = {
                type: "ui.".concat(r),
                data: {
                  message: (function() {
                    if (!a || 1 !== a.nodeType) return "";
                    for (
                      var e = a || null,
                        t = [],
                        r = 0,
                        n = 0,
                        o = " > ".length,
                        i = "";
                      e &&
                      r++ < 5 &&
                      !(
                        "html" ===
                          (i = (function(e) {
                            var t,
                              r,
                              n,
                              o,
                              i = [];
                            if (!e || "string" != typeof e.tagName) return "";
                            if (
                              (i.push(e.tagName.toLowerCase()),
                              "string" == typeof e.id &&
                                i.push("#".concat(e.id)),
                              "string" == typeof (t = e.className))
                            )
                              for (r = t.split(/\s+/), s = 0; s < r.length; s++)
                                i.push(".".concat(r[s]));
                            for (
                              var a = [
                                  "type",
                                  "name",
                                  "title",
                                  "alt",
                                  "data-arms-attr",
                                ],
                                s = 0;
                              s < a.length;
                              s++
                            )
                              "string" ==
                                typeof (o = e.getAttribute((n = a[s]))) &&
                                i.push("[".concat(n, '="').concat(o, '"]'));
                            return i.join("");
                          })(e)) ||
                        (1 < r && 80 <= n + t.length * o + i.length)
                      );

                    )
                      t.push(i), (n += i.length), (e = e.parentNode);
                    return t.reverse().join(" > ");
                  })(),
                },
                timestamp: Date.now(),
              }),
              "click" === r
                ? (o && clearTimeout(o),
                  n
                    ? (o = setTimeout(function() {
                        u && u.addBehavior(t);
                      }, 0))
                    : u && u.addBehavior(t))
                : "keypress" === r &&
                  (i || (u && u.addBehavior(t)),
                  clearTimeout(i),
                  (i = setTimeout(function() {
                    i = void 0;
                  }, 100))));
          }
        };
      }
      var n = [],
        u = null,
        l = s && s.location && s.location.href,
        o = 0,
        i = void 0,
        f = null;
      p.ext(e.prototype, {
        addBehavior: function(e) {
          if (this.getConfig("behavior") && e && "object" == typeof e) {
            var t = {},
              r = e.data || {};
            if (e.type) t = r;
            else {
              if ("string" != typeof r.name || "string" != typeof r.message)
                return;
              (t.name = r.name.substr(0, 20)),
                (t.message = r.message.substr(0, 200));
            }
            t.message && (t.message = p.encode(t.message));
            e = {
              type: e.type || "custom",
              data: t || {},
              timestamp: e.timestamp || Date.now(),
              page: e.page || (s && s.location && s.location.pathname),
            };
            return n.push(e), (n = n.slice(-100));
          }
        },
        getBehavior: function() {
          return n || [];
        },
        setBehavior: function(e) {
          return (n = e ? e : n);
        },
        reportBehavior: function(e) {
          var t = this;
          t.getConfig("behavior") &&
            (t.sendBhTimer &&
              (clearTimeout(t.sendBhTimer), (t.sendBhTimer = void 0)),
            (t.sendBhTimer = setTimeout(function() {
              n &&
                0 < n.length &&
                (t.behavior(n),
                (n = []),
                (t.sendBhTimer = void 0),
                e && "function" == typeof e && e());
            }, 0)));
        },
        initBehavior: function() {
          if (!this.hasInitBehavior && !u) {
            try {
              document &&
                document.referrer &&
                document.location &&
                ((r = document.referrer),
                (n = document.location.href),
                "" !== r &&
                  ((l = n),
                  u &&
                    u.addBehavior({
                      type: "navigation",
                      data: { from: r, to: n },
                    }))),
                s &&
                  s.document &&
                  s.document.addEventListener &&
                  (s.document.addEventListener("click", c("click"), !1),
                  s.document.addEventListener("keypress", c("keypress"), !1)),
                (e = s && s.chrome),
                (t = e && e.app && e.app.runtime),
                (e =
                  "history" in s &&
                  !!s.history.pushState &&
                  !!s.history.replaceState),
                !t &&
                  e &&
                  ((i = function(e, t) {
                    u &&
                      u.addBehavior({
                        type: "navigation",
                        data: { from: e, to: t },
                      }),
                      (l = t);
                  }),
                  (o = s.onpopstate),
                  (s.onpopstate = function() {
                    for (
                      var e = arguments.length, t = new Array(e), r = 0;
                      r < e;
                      r++
                    )
                      t[r] = arguments[r];
                    var n = s.location.href;
                    if ((i(l, n), o)) return o.apply(this, t);
                  }),
                  a(
                    s.history,
                    "pushState",
                    (e = function(o) {
                      return function() {
                        for (
                          var e = arguments.length, t = new Array(e), r = 0;
                          r < e;
                          r++
                        )
                          t[r] = arguments[r];
                        var n = 2 < t.length ? t[2] : void 0;
                        return n && i(l, String(n)), o.apply(this, t);
                      };
                    })
                  ),
                  a(s.history, "replaceState", e)),
                this.getConfig("enableConsole") &&
                  (function() {
                    if (s && s.console)
                      for (
                        var e = [
                            "debug",
                            "info",
                            "warn",
                            "log",
                            "error",
                            "assert",
                          ],
                          t = 0;
                        t < e.length;
                        t++
                      ) {
                        var r = e[t];
                        s.console[r] &&
                          "function" == typeof s.console[r] &&
                          a(s.console, r, function(i) {
                            var a = r;
                            return function() {
                              for (
                                var e = arguments.length,
                                  t = new Array(e),
                                  r = 0;
                                r < e;
                                r++
                              )
                                t[r] = arguments[r];
                              if (
                                (u &&
                                  u.addBehavior({
                                    type: "console",
                                    data: { level: a, message: t },
                                  }),
                                "error" === a)
                              )
                                for (var n = 0; n < t.length; n++) {
                                  var o = t[n];
                                  o &&
                                    o.message &&
                                    o.stack &&
                                    u &&
                                    u.errorHandler(
                                      new ErrorEvent("error", {
                                        error: o,
                                        message: o.message,
                                      })
                                    );
                                }
                              i &&
                                Function.prototype.apply.call(i, s.console, t);
                            };
                          });
                      }
                  })();
            } catch (e) {
              p.warn("[arms] error in initBehavior", e);
            }
            (u = this).hasInitBehavior = !0;
          }
          var i, o, e, t, r, n;
          return this;
        },
      });
    };
  },
  function(e, t, g) {
    e.exports = function(e, n, s) {
      function t(e, t, r, n, o) {
        if (void 0 === t) {
          var i, a;
          if (!h[e]) {
            i = new RegExp(e + "=([^;]+)");
            try {
              a = i.exec(s.cookie);
            } catch (e) {
              return c.warn("[retcode] can not get cookie:", e), null;
            }
            a && (h[e] = a[1]);
          }
          return h[e];
        }
        (t = e + "=" + t),
          n && (t += "; domain=" + n),
          (t += "; path=" + (o || "/")),
          r && (t += "; max-age=" + r);
        try {
          return (s.cookie = t), !!s.cookie;
        } catch (e) {
          return c.warn("[retcode] can not set cookie: ", e), !1;
        }
      }
      function o(e) {
        return (e = e._conf.uid || t("_nk_") || t("_bl_uid")) ||
          ((e = c.uu()), t("_bl_uid", e, 15552e3))
          ? e
          : null;
      }
      var c = g(0),
        i = g(42),
        a = g(43),
        r = null,
        u = s.documentElement,
        l = n.innerWidth || u.clientWidth || s.body.clientWidth,
        f = n.innerHeight || u.clientHeight || s.body.clientHeight,
        p = n.navigator.connection,
        d = {
          sr: screen.width + "x" + screen.height,
          vp: l + "x" + f,
          ct: p ? p.effectiveType || p.type : "",
        },
        h = {};
      return (
        c.ext(e.prototype, {
          activeErrHandler: function(e) {
            return (r && !e) || (r = this), this;
          },
          errorHandler: function(e) {
            if (!e) return this;
            var t,
              r = e.type;
            "error" === r
              ? !(t = e.target || e.srcElement) ||
                !t.tagName ||
                e.message ||
                e.filename ||
                e.lineno ||
                e.colno
                ? this.error(e.error || { message: e.message }, e)
                : this.resourceErrorHandler(e)
              : "unhandledrejection" === r &&
                c.T(e.reason, "Error") &&
                c.checkAutoError(e.reason) &&
                this.error(e.reason);
            try {
              this.getConfig("behavior") &&
                this.reportBehavior &&
                this.reportBehavior();
            } catch (e) {}
            return this;
          },
          resourceErrorHandler: function(e) {
            var t = this,
              e = e.target || e.srcElement;
            try {
              var r = t.getSrc(e),
                n = "string" == typeof e.tagName ? e.tagName.toLowerCase() : "",
                o = t.getXPath(e, 5);
              return (
                t._lg("resourceError", {
                  src: r && r.substring(0, 1e3),
                  node_name: n,
                  xpath: o,
                }),
                t
              );
            } catch (e) {
              return c.warn("[ARMS] resourceErrorHandler error :", e), t;
            }
          },
          getSrc: function(e) {
            var t,
              r,
              n = e.src || e.href;
            try {
              n ||
                ((t =
                  "object" ===
                  ("string" == typeof e.tagName
                    ? e.tagName.toLowerCase()
                    : "")),
                (r =
                  (e.getAttribute("classid") &&
                    "clsid:d27cdb6e-ae6d-11cf-96b8-444553540000" ===
                      e.getAttribute("classid").toLowerCase()) ||
                  "application/x-shockwave-flash" === e.getAttribute("type")),
                (n =
                  (n =
                    t && r
                      ? e.getAttribute("data") || e.getAttribute("codebase")
                      : n) ||
                  e.outerHTML ||
                  e.innerHTML));
            } catch (e) {
              n = "";
            }
            return n;
          },
          getXPath: function(e, t) {
            var r = e.id ? "#" + e.id : "",
              n =
                "string" == typeof e.className
                  ? "." + e.className.split(" ").join(".")
                  : "",
              n =
                ("string" == typeof e.tagName ? e.tagName.toLowerCase() : "") +
                r +
                n;
            return e.parentNode && e.parentNode.tagName && t - 1 != 0
              ? this.getXPath(e.parentNode, t - 1) + " > " + n
              : n;
          },
          sendPerformance: function(t) {
            var r = this;
            r.onReady(function() {
              var e = a();
              e &&
                e.load &&
                0 < e.load &&
                ((e.page = r.getPage(!0)),
                ((e = t ? c.ext(e, t) : e).autoSend = !0),
                r.performance(e));
            });
          },
          sendResources: function(t) {
            var r = this;
            r.onReady(function() {
              var e = i();
              e &&
                e.load &&
                0 < e.load &&
                ((e.load && e.load <= 2e3) ||
                  (e.load && e.load <= 8e3 && 0.05 < Math.random()) ||
                  ((e.page = r.getPage(!0)),
                  (e.dl = location.href),
                  t && (e = c.ext(e, t)),
                  r._lg("res", e, r.getConfig("sample"))));
            });
          },
          sendPV: function() {
            var r = this;
            r.onReady(function() {
              var e,
                t,
                t =
                  ((e = o(r)),
                  (t = n.devicePixelRatio || 1),
                  {
                    uid: e,
                    dt: s.title,
                    dl: location.href,
                    dr: s.referrer,
                    dpr: t.toFixed(2),
                    de: (
                      s.characterSet ||
                      s.defaultCharset ||
                      ""
                    ).toLowerCase(),
                    ul: u.lang,
                    begin: Date.now(),
                  });
              t.uid && r._lg("pv", t, r.getConfig("pvSample"));
            });
          },
          commonInfo: function() {
            return (
              (d.uid = o(this)),
              (d.sid = (function(e) {
                if (e.session) return e.session;
                var t;
                try {
                  if (
                    "object" == typeof window &&
                    "object" == typeof sessionStorage &&
                    "function" == typeof sessionStorage.getItem
                  )
                    return (
                      "string" == typeof (t = sessionStorage.getItem("_bl_sid"))
                        ? (e.session = t)
                        : ((t = c.uu()),
                          (e.session = t),
                          "function" == typeof sessionStorage.setItem &&
                            sessionStorage.setItem("_bl_sid", t)),
                      t
                    );
                } catch (e) {
                  c.warn("[ARMS] getSid error :", e);
                }
                return (e.session = t = c.uu()), t;
              })(this)),
              d
            );
          },
          handleUnload: function(e) {
            var t = Date.now();
            if (t - this._lastUnload < 200) return this;
            (this._lastUnload = t),
              this.sendHealth(e),
              this.speedCache &&
                (this._lg("speed", this.speedCache),
                (this.speedCache = null),
                clearTimeout(this.speedTimmer)),
              this.clear(!0);
          },
          bindHashChange: function(e) {
            var r = this;
            if (!e ^ r.hashChangeHandler) return r;
            e
              ? (r.hackHistoryState(),
                (r.hashChangeHandler = function(e) {
                  var t = r._conf.parseHash(location.hash);
                  t && r.setPage(t, !1 !== e);
                }),
                (r.stateChangeHandler = function(e) {
                  e = r._conf.parseHash(e.detail);
                  e && r.setPage(e);
                }),
                c.on(n, "hashchange", r.hashChangeHandler),
                c.on(n, "historystatechange", r.stateChangeHandler),
                r.hashChangeHandler(!1))
              : (c.off(n, "hashchange", r.hashChangeHandler),
                c.off(n, "historystatechange", r.stateChangeHandler),
                (r.hashChangeHandler = null),
                (r.stateChangeHandler = null));
          },
          initHandler: function() {
            var e = this;
            if (e.hasInitHandler) return e;
            var t = e._conf;
            return (
              c.on(n, "beforeunload", function() {
                e.handleUnload(0);
              }),
              e.bindHashChange(t.enableSPA),
              e.activeErrHandler(!1),
              (e.hasInitHandler = !0),
              e
            );
          },
        }),
        c
          .on(
            n,
            "error",
            function(e) {
              r && r.errorHandler(e);
            },
            !1,
            !0
          )
          .on(n, "unhandledrejection", function(e) {
            r && r.errorHandler(e);
          }),
        e
      );
    };
  },
  function(e, t, r) {
    var a = r(0),
      s = r(11).TIMING_KEYS;
    e.exports = function() {
      var e = a.win || {},
        t = e.performance;
      if (!t || "object" != typeof t || "function" != typeof t.getEntriesByType)
        return null;
      var r,
        n = {},
        o = t.timing || {},
        i = t.getEntriesByType("resource") || [];
      return (
        (n.begin = o[s[1]] || Date.now()),
        "function" == typeof e.PerformanceNavigationTiming &&
          (r = t.getEntriesByType("navigation")[0]) &&
          (o = r),
        a.each({ dom: [10, 8], load: [14, 1] }, function(e, t) {
          var r = o[s[e[1]]],
            e = o[s[e[0]]];
          0 < r &&
            0 < e &&
            0 <= (r = Math.round(e - r)) &&
            r < 6e5 &&
            (n[t] = r);
        }),
        (n.res = JSON.stringify(i)),
        n
      );
    };
  },
  function(e, t, r) {
    var c = r(0),
      u = r(11).TIMING_KEYS;
    e.exports = function() {
      var e = c.win || {},
        t = e.performance;
      if (!t || "object" != typeof t) return null;
      var r,
        n = {},
        o = t.timing || {},
        i = Date.now(),
        a = 1;
      "function" != typeof e.PerformanceNavigationTiming ||
        ((r = t.getEntriesByType("navigation")[0]) && ((o = r), (a = 2))),
        c.each(
          {
            dns: [3, 2],
            tcp: [5, 4],
            ssl: [5, 17],
            ttfb: [7, 6],
            trans: [8, 7],
            dom: [10, 8],
            res: [14, 12],
            firstbyte: [7, 2],
            fpt: [8, 1],
            tti: [10, 1],
            ready: [12, 1],
            load: [14, 1],
          },
          function(e, t) {
            var r = o[u[e[1]]],
              e = o[u[e[0]]];
            !(2 === a || (0 < r && 0 < e)) ||
              (0 <= (r = Math.round(e - r)) && r < 6e5 && (n[t] = r));
          }
        );
      (e = e.navigator.connection), (t = t.navigation || {});
      n.ct = e ? e.effectiveType || e.type : "";
      var s,
        e = (e && (e.downlink || e.downlinkMax || e.bandwidth)) || null;
      return (
        (e = 999 < e ? 999 : e) && (n.bandwidth = e),
        (n.navtype = 1 === t.type ? "Reload" : "Other"),
        1 === a &&
          0 < o[u[16]] &&
          0 < o[u[1]] &&
          0 <= (s = o[u[16]] - o[u[1]]) &&
          s < 36e5 &&
          (n.fpt = s),
        1 === a && 0 < o[u[1]]
          ? (n.begin = o[u[1]])
          : 2 === a && 0 < n.load
          ? (n.begin = i - n.load)
          : (n.begin = i),
        n
      );
    };
  },
  function(e, t, r) {
    var l = r(0);
    e.exports = function(e, r, o) {
      var c = r.innerHeight || 0,
        a = [],
        s = null,
        u = 0;
      l.ext(e.prototype, {
        initFmpObserver: function(e) {
          var n = this;
          if (!n._conf || !n._conf.useFmp) return null;
          if (!r.MutationObserver)
            return (
              l.warn("[retcode] first meaningful paint can not be retrieved"),
              n.sendPerformance(),
              null
            );
          l.on(r, "beforeunload", function() {
            n.endObserving(0, !0);
          });
          var t = r.MutationObserver;
          return (
            (s = new t(function() {
              var e, t, r;
              (e = n._startTime),
                (t = Date.now() - e),
                (r = o.querySelector("body"))
                  ? ((e = 0),
                    (e += (function e(t, r, n) {
                      var o = 0,
                        i = t.tagName;
                      if (
                        "SCRIPT" !== i &&
                        "STYLE" !== i &&
                        "META" !== i &&
                        "HEAD" !== i
                      ) {
                        if (0 < (i = t.children ? t.children.length : 0))
                          for (var a = t.children, s = i - 1; 0 <= s; s--)
                            o += e(a[s], r + 1, 0 < o);
                        if (
                          o <= 0 &&
                          !n &&
                          !(
                            t.getBoundingClientRect &&
                            t.getBoundingClientRect().top < c
                          )
                        )
                          return 0;
                        o += 1 + 0.5 * r;
                      }
                      return o;
                    })(r, 1, !1)),
                    a.push({ score: e, t: t }))
                  : a.push({ score: 0, t: t });
            })).observe(document, { childList: !0, subtree: !0 }),
            (u = 1),
            n.onReady(function() {
              n.endObserving(e);
            }),
            s
          );
        },
        endObserving: function(e, t) {
          var r = this;
          if (s && u)
            if (
              (r.fmpTimmer && (clearTimeout(r.fmpTimmer), (r.fmpTimmer = null)),
              t ||
                !(function(e, t) {
                  e = Date.now() - e;
                  return !(
                    t < e ||
                    1e3 < e - ((a && a.length && a[a.length - 1].t) || 0)
                  );
                })(r._startTime, e))
            ) {
              s.disconnect(),
                (u = 0),
                (a = (function e(t) {
                  for (var r = 1; r < t.length; r++)
                    if (t[r].score < t[r - 1].score)
                      return t.splice(r, 1), e(t);
                  return t;
                })(a));
              for (var n, o = null, i = 1; i < a.length; i++)
                a[i].t >= a[i - 1].t &&
                  ((n = a[i].score - a[i - 1].score),
                  (!o || o.rate <= n) && (o = { t: a[i].t, rate: n }));
              o && 0 < o.t && o.t < 36e5
                ? r.sendPerformance({ fmp: o.t })
                : r.sendPerformance();
            } else
              r.fmpTimmer = l.delay(function() {
                r.endObserving(e);
              }, 500);
        },
      });
    };
  },
  function(e, t, r) {
    e.exports = function(e, S) {
      function E(e, t, r, n, o, i, a, s, c, u, l, f, p) {
        (o = C.J(o) || null),
          (o = C.safetyCall(t, [o, n], null)) &&
            ((n = o.code || i),
            (i = !("success" in o) || o.success),
            e.api(r, i, a, n, o.msg, s, c, u, l, k, f, p));
      }
      var C = r(0),
        x = null,
        k = C.getCurDomain(),
        n = "fetch",
        o = "__oFetch_",
        i = "__oXMLHttpRequest_",
        a = "XMLHttpRequest";
      return (
        C.ext(e.prototype, {
          removeHook: function(e, t) {
            return (
              x &&
                (t || this === x) &&
                (S[o] && ((S[n] = S[o]), delete S[o]),
                S[i] && ((S[a] = S[i]), delete S[i]),
                (x = null)),
              this
            );
          },
          addHook: function(e) {
            return (
              (!e && x) ||
                (x ||
                  ("function" == typeof S[n] &&
                    ((b = S[n]),
                    (S[o] = b),
                    (S[n] = function(e, t) {
                      var a =
                          1 === arguments.length
                            ? [e]
                            : Array.apply(null, arguments),
                        s = x;
                      if (!s || !s.api) return b.apply(S, a);
                      if (t && ("HEAD" === t.method || "no-cors" === t.mode))
                        return b.apply(S, a);
                      var c = Date.now(),
                        u = s._conf,
                        l = (f = (e && "string" != typeof e ? e.url : e) || ""),
                        f = C.cutUrlSearch(f),
                        r = (u.ignore || {}).ignoreApis;
                      if (!C.checkAPI(f, !0) || C.ignoreByRule(f, r))
                        return b.apply(S, a);
                      f = C.filterByRule(f, u.ignoreApiPath || u.apiHelper);
                      var n = u.enableLinkTrace,
                        p = "",
                        d = "",
                        o = s.getConfig("pid"),
                        h = null,
                        i = s.getConfig("sample"),
                        r = s.getConfig("linkType"),
                        g = 1;
                      if ((i && !s.sampling(i) && (g = 0), n)) {
                        n = "";
                        try {
                          n =
                            location.origin ||
                            location.protocol +
                              "//" +
                              location.hostname +
                              (location.port ? ":" + location.port : "");
                        } catch (e) {
                          n = "";
                        }
                        var m,
                          y,
                          v,
                          w,
                          n = C.checkSameOrigin(l, n);
                        if (s.getConfig("enableApiCors") || n) {
                          if (e && "string" != typeof e)
                            try {
                              a[0].headers &&
                                "function" == typeof a[0].headers.get &&
                                "function" == typeof a[0].headers.append &&
                                ("tracing" === r
                                  ? ((m = a[0].headers.get("uber-trace-id")),
                                    (p = m
                                      ? m.split(":")[0]
                                      : ((m = s.getUberTraceId(g)),
                                        a[0].headers.append(
                                          "uber-trace-id",
                                          m["uber-trace-id"]
                                        ),
                                        m.traceId)),
                                    (d = s.pageview))
                                  : ((y = a[0].headers.get("EagleEye-TraceID")),
                                    (v = a[0].headers.get(
                                      "EagleEye-SessionID"
                                    )),
                                    (w = a[0].headers.get("EagleEye-pAppName")),
                                    y
                                      ? (p = y)
                                      : ((p = s.getTraceId()[
                                          "EagleEye-TraceID"
                                        ]),
                                        a[0].headers.append(
                                          "EagleEye-TraceID",
                                          p
                                        )),
                                    v
                                      ? (d = v)
                                      : ((d = s.getPageviewId()[
                                          "EagleEye-SessionID"
                                        ]),
                                        a[0].headers.append(
                                          "EagleEye-SessionID",
                                          d
                                        )),
                                    w ||
                                      a[0].headers.append(
                                        "EagleEye-pAppName",
                                        o
                                      )));
                            } catch (e) {
                              C.warn(
                                "[retcode] fetch failed to set header, exception is :\n" +
                                  e
                              );
                            }
                          t &&
                            ("tracing" === ((t.headers = t.headers || {}), r)
                              ? ((p = t.headers["uber-trace-id"]
                                  ? t.headers["uber-trace-id"].split(":")[0]
                                  : ((r = s.getUberTraceId(g)),
                                    (t.headers["uber-trace-id"] =
                                      r["uber-trace-id"]),
                                    r.traceId)),
                                (d = s.getPageviewId()["EagleEye-SessionID"]))
                              : (t.headers["EagleEye-TraceID"]
                                  ? (p = t.headers["EagleEye-TraceID"])
                                  : ((p = s.getTraceId()["EagleEye-TraceID"]),
                                    (t.headers["EagleEye-TraceID"] = p)),
                                t.headers["EagleEye-SessionID"]
                                  ? (d = t.headers["EagleEye-SessionID"])
                                  : ((d = s.getPageviewId()[
                                      "EagleEye-SessionID"
                                    ]),
                                    (t.headers["EagleEye-SessionID"] = d)),
                                t.headers["EagleEye-pAppName"] ||
                                  (t.headers["EagleEye-pAppName"] = o)));
                        }
                      }
                      return b
                        .apply(S, a)
                        .then(function(t) {
                          if (!s || !s.api) return t;
                          try {
                            if (!t || "function" != typeof t.clone) return t;
                            var r = t.clone(),
                              n = r.headers;
                            if (n && "function" == typeof n.get) {
                              var e,
                                o = n.get("content-type");
                              if (o && !/(text)|(json)/.test(o)) return t;
                              p ||
                                ("object" ==
                                  typeof (e = C.parseFetchHeaders(n)) &&
                                  e["eagleeye-traceid"] &&
                                  ((p = e["eagleeye-traceid"]),
                                  (h = "response")));
                            }
                            var i = Date.now() - c;
                            return (
                              r.text().then(function(e) {
                                var t = C.getFetchSnapshot(a, e, n);
                                r.ok
                                  ? E(
                                      s,
                                      u.parseResponse,
                                      f,
                                      l,
                                      e,
                                      r.status || 200,
                                      i,
                                      c,
                                      p,
                                      d,
                                      t,
                                      h,
                                      g
                                    )
                                  : s.api(
                                      f,
                                      !1,
                                      i,
                                      r.status || 404,
                                      r.statusText,
                                      c,
                                      p,
                                      d,
                                      t,
                                      k,
                                      h,
                                      g
                                    );
                              }),
                              t
                            );
                          } catch (e) {
                            return (
                              C.warn("[ARMS] fetch response error :", e), t
                            );
                          }
                        })
                        .catch(function(e) {
                          if (!s || !s.api) throw e;
                          var t = Date.now() - c;
                          throw (s.api(
                            f,
                            !1,
                            t,
                            e.name || "Error",
                            e.message,
                            c,
                            p,
                            d,
                            {},
                            k
                          ),
                          e);
                        });
                    }),
                    (S[n].toString = C.createFakeToString(n))),
                  "function" == typeof S[a] &&
                    ((r = S[a]),
                    (S[i] = r),
                    ((e = function(e) {
                      var o = new r(e),
                        i = x;
                      if (!i || !i.api || !o.addEventListener) return o;
                      var a,
                        s,
                        c,
                        n,
                        t = o.send,
                        u = o.open,
                        l = o.setRequestHeader,
                        f = i._conf,
                        p = (f.ignore || {}).ignoreApis,
                        d = i.getConfig("enableLinkTrace"),
                        h = "",
                        g = "",
                        m = null,
                        e = i.getConfig("sample"),
                        y = i.getConfig("linkType"),
                        v = 1;
                      return (
                        e && !i.sampling(e) && (v = 0),
                        (o.open = function(e, t) {
                          w = e;
                          var r =
                            1 === arguments.length
                              ? [e]
                              : Array.apply(null, arguments);
                          u.apply(o, r), (c = t || ""), (s = C.cutUrlSearch(c));
                          r = !C.checkAPI(s, !0) || C.ignoreByRule(s, p);
                          if (
                            ((s = s
                              ? C.filterByRule(
                                  s,
                                  f.ignoreApiPath || f.apiHelper
                                )
                              : ""),
                            !r && d)
                          ) {
                            r = "";
                            try {
                              r =
                                location.origin ||
                                location.protocol +
                                  "//" +
                                  location.hostname +
                                  (location.port ? ":" + location.port : "");
                            } catch (e) {
                              r = "";
                            }
                            r = C.checkSameOrigin(c, r);
                            (i.getConfig("enableApiCors") || r) &&
                              l &&
                              "function" == typeof l &&
                              ("tracing" === y
                                ? ((r = i.getUberTraceId(v)),
                                  l.apply(o, [
                                    "uber-trace-id",
                                    r["uber-trace-id"],
                                  ]),
                                  (h = r.traceId),
                                  (g = i.getPageviewId()["EagleEye-SessionID"]))
                                : ((h = i.getTraceId()["EagleEye-TraceID"]),
                                  l.apply(o, ["EagleEye-TraceID", h]),
                                  (g = i.getPageviewId()["EagleEye-SessionID"]),
                                  l.apply(o, ["EagleEye-SessionID", g]),
                                  (n = i.getConfig("pid")),
                                  l.apply(o, ["EagleEye-pAppName", n])));
                          }
                        }),
                        (o.send = function() {
                          a = Date.now();
                          var e =
                            1 === arguments.length
                              ? [arguments[0]]
                              : Array.apply(null, arguments);
                          t.apply(o, e);
                        }),
                        C.on(o, "readystatechange", function() {
                          if (s && 4 === o.readyState) {
                            var e = Date.now() - a,
                              t = C.getXhrSnapshot(c, w, o);
                            if (
                              (h ||
                                ("object" ==
                                  typeof (n = C.parseXhrHeaders(
                                    ("function" ==
                                      typeof o.getAllResponseHeaders &&
                                      o.getAllResponseHeaders()) ||
                                      ""
                                  )) &&
                                  n["eagleeye-traceid"] &&
                                  ((h = n["eagleeye-traceid"]),
                                  (m = "response"))),
                              200 <= o.status && o.status <= 299)
                            ) {
                              var r = o.status || 200;
                              if ("function" == typeof o.getResponseHeader) {
                                var n = o.getResponseHeader("Content-Type");
                                if (n && !/(text)|(json)/.test(n)) return;
                              }
                              o.responseType && "text" !== o.responseType
                                ? i.api(s, !0, e, r, "", a, h, g, {}, k, m, v)
                                : E(
                                    i,
                                    f.parseResponse,
                                    s,
                                    c,
                                    o.responseText,
                                    r,
                                    e,
                                    a,
                                    h,
                                    g,
                                    t,
                                    m,
                                    v
                                  );
                            } else
                              i.api(
                                s,
                                !1,
                                e,
                                o.status || "FAILED",
                                o.statusText,
                                a,
                                h,
                                g,
                                t,
                                k,
                                m,
                                v
                              );
                          }
                        }),
                        o
                      );
                    }).prototype = r.prototype),
                    (S[a] = e),
                    (S[a].toString = C.createFakeToString(a)))),
                (x = this)),
              this
            );
            var w, r, b;
          },
          initHook: function() {
            return (
              this.hasInitHook ||
                (this.getConfig("disableHook") || this.addHook(),
                (this.hasInitHook = !0)),
              this
            );
          },
        }),
        e
      );
    };
  },
  function(e, t, r) {
    e.exports = function(e, n) {
      function d(e, t) {
        var r;
        n.CustomEvent
          ? (r = new CustomEvent(e, { detail: t }))
          : ((r = o.createEvent("HTMLEvents")).initEvent(e, !1, !0),
            (r.detail = t)),
          n.dispatchEvent(r);
      }
      function t(f) {
        var p = g[f];
        "function" == typeof p &&
          ((g[f] = function(e, t, r) {
            var n = 1 === arguments.length ? [e] : Array.apply(null, arguments),
              o = location.href,
              n = p.apply(g, n);
            if (!r || "string" != typeof r) return n;
            if (r === o) return n;
            try {
              var i = o.split("#"),
                a = r.split("#"),
                s = h.cutUrlSearch(i[0]),
                c = h.cutUrlSearch(a[0]),
                u = i[1] && i[1].replace(/^\/?(.*)/, "$1"),
                l = a[1] && a[1].replace(/^\/?(.*)/, "$1");
              s !== c
                ? d("historystatechange", c)
                : u !== l && d("historystatechange", l);
            } catch (e) {
              h.warn("[retcode] error in " + f + ": " + e);
            }
            return n;
          }),
          (g[f].toString = h.createFakeToString(f)));
      }
      var h = r(0),
        g = n.history || {},
        o = n.document;
      h.ext(e.prototype, {
        hackHistoryState: function() {
          return (
            this.hasHackedHistoryState ||
              (t("pushState"),
              t("replaceState"),
              (this.hasHackedHistoryState = !0)),
            this
          );
        },
      });
    };
  },
  function(e, t, r) {
    "use strict";
    function o(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n);
      }
    }
    r.r(t);
    var i = (function() {
      function e() {
        !(function(e, t) {
          if (!(e instanceof t))
            throw new TypeError("Cannot call a class as a function");
        })(this, e),
          (this.isFallBack = !0);
      }
      var t, r, n;
      return (
        (t = e),
        (r = [
          {
            key: "privateJSApis",
            value: function() {
              return [];
            },
          },
          {
            key: "setTitle",
            value: function() {
              console.error("fallback 策略");
            },
          },
        ]) && o(t.prototype, r),
        n && o(t, n),
        e
      );
    })();
    function a(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n);
      }
    }
    var s = [
      "setTitle",
      "setMenu",
      "close",
      "getUserType",
      "zmAuthentication",
      "kexinAuthentication",
      "realAuthentication",
      "getLocation",
      "phoneCall",
      "getUUID",
      "sms",
      "getNetworkType",
      "getSystemInfo",
      "openLink",
      "getLocalStorage",
      "removeLocalStorage",
      "setLocalStorage",
      "monitorTrace",
      "getCurrentLocationCity",
      "selectCity",
      "saveImage",
      "chooseImage",
      "scan",
      "pay",
      "share",
      "directShare",
      "confirm",
      "hidePreloader",
      "showPreloader",
      "alert",
      "toast",
      "prompt",
      "actionSheet",
      "egop",
      "setClipboardData",
    ];
    window.MultiportJSApis = s;
    var n = (function() {
      function e() {
        !(function(e, t) {
          if (!(e instanceof t))
            throw new TypeError("Cannot call a class as a function");
        })(this, e),
          (this.adapterInited = !1),
          (this.readyCallback = null),
          this.registerAdapter(new i()),
          this.registerEventListener();
      }
      var t, r, n;
      return (
        (t = e),
        (r = [
          {
            key: "registerAdapter",
            value: function(e) {
              this.registerMultiportJSApis(e), this.registerPrivateJSApis(e);
            },
          },
          {
            key: "onReady",
            value: function(e) {
              (this.readyCallback = e), this.checkReady();
            },
          },
          {
            key: "jsbridgeReady",
            value: function() {
              document.dispatchEvent(new Event("ZWJSBridgeAdapterReady"));
            },
          },
          {
            key: "registerMultiportJSApis",
            value: function(r) {
              var e = this;
              s.forEach(function(t) {
                r[t]
                  ? (e[t] = function() {
                      var e =
                        0 < arguments.length && void 0 !== arguments[0]
                          ? arguments[0]
                          : {};
                      return window.__zwbl.sum("apiCall_" + t, 1), r[t](e);
                    })
                  : r.isFallBack ||
                    console.warn(
                      'ZWJSBridge: 基础JSAPI "'.concat(t, '" 未实现')
                    );
              });
            },
          },
          {
            key: "registerPrivateJSApis",
            value: function(t) {
              var r = this;
              t.privateJSApis().forEach(function(e) {
                r[e] = function() {
                  return t[e](
                    0 < arguments.length && void 0 !== arguments[0]
                      ? arguments[0]
                      : {}
                  );
                };
              });
            },
          },
          {
            key: "registerEventListener",
            value: function() {
              var e = this;
              document.addEventListener("ZWJSBridgeAdapterReady", function() {
                (e.adapterInited = !0), e.checkReady();
              });
            },
          },
          {
            key: "checkReady",
            value: function() {
              this.adapterInited && this.readyCallback && this.readyCallback();
            },
          },
        ]) && a(t.prototype, r),
        n && a(t, n),
        e
      );
    })();
    function c(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n);
      }
    }
    function u(t, e) {
      var r,
        n = Object.keys(t);
      return (
        Object.getOwnPropertySymbols &&
          ((r = Object.getOwnPropertySymbols(t)),
          e &&
            (r = r.filter(function(e) {
              return Object.getOwnPropertyDescriptor(t, e).enumerable;
            })),
          n.push.apply(n, r)),
        n
      );
    }
    function l(n) {
      for (var e = 1; e < arguments.length; e++) {
        var o = null != arguments[e] ? arguments[e] : {};
        e % 2
          ? u(Object(o), !0).forEach(function(e) {
              var t, r;
              (t = n),
                (e = o[(r = e)]),
                r in t
                  ? Object.defineProperty(t, r, {
                      value: e,
                      enumerable: !0,
                      configurable: !0,
                      writable: !0,
                    })
                  : (t[r] = e);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(o))
          : u(Object(o)).forEach(function(e) {
              Object.defineProperty(
                n,
                e,
                Object.getOwnPropertyDescriptor(o, e)
              );
            });
      }
      return n;
    }
    Proxy
      ? (window.ZWJSBridge = new Proxy(new n(), {
          get: function(e, t) {
            return void 0 !== e[t]
              ? e[t]
              : function() {
                  var o =
                    0 < arguments.length && void 0 !== arguments[0]
                      ? arguments[0]
                      : {};
                  return new Promise(function(r, n) {
                    window.JupiterJSBridge
                      ? JupiterJSBridge.call(
                          "eGovernmentApi",
                          { apiName: t, params: o },
                          function(e) {
                            var t = (e =
                                "string" == typeof e ? JSON.parse(e) : e),
                              e = e.errorCode;
                            "0" === e || 0 === e
                              ? o.onSuccess
                                ? o.onSuccess(t.data || t.result || {})
                                : r(t.data || t.result || {})
                              : o.onFail
                              ? o.onFail(t)
                              : n(t);
                          }
                        )
                      : console.log("未实现 JupiterJSBridge");
                  });
                };
          },
        }))
      : (window.ZWJSBridge = new n());
    var f = {
        busCardAuth: "biz.busCard.auth",
        busCardReceive: "biz.busCard.receive",
        busCardList: "biz.busCard.list",
        busCardAllList: "biz.busCard.allList",
        busCardFirst: "biz.busCard.first",
        busCardDetail: "biz.busCard.detail",
        busCardCities: "biz.busCard.cities",
        zjnavi: "biz.map.zjnavi",
        clipBoardSetData: "biz.clipboardData.setData",
        esscsdkCheckPassword: "biz.user.esscsdkCheckPassword",
        padTaskCallback: "padTaskCallback",
      },
      p = l(
        {
          lifeCycleCallback: "lifeCycleCallback",
          setTitle: "biz.navigation.setTitle",
          setMenu: "setMenu",
          close: "biz.navigation.close",
          getUserType: "biz.user.getUserType",
          getUserInfo: "biz.user.getUserInfo",
          zmAuthentication: "biz.user.realAuthentication",
          realAuthentication: "biz.user.realAuthentication",
          kexinAuthentication: "biz.user.policeRealAuthentication",
          getLocation: "device.location.get",
          phoneCall: "biz.telephone.call",
          getUUID: "device.base.getUUID",
          sms: "biz.telephone.sms",
          getNetworkType: "device.connection.getNetworkType",
          getSystemInfo: "device.systemInfo.get",
          openLink: "biz.util.openLink",
          getLocalStorage: "util.localStorage.getItem",
          removeLocalStorage: "util.localStorage.removeItem",
          setLocalStorage: "util.localStorage.setItem",
          monitorTrace: "biz.util.trace",
          getCurrentLocationCity: "biz.util.selectLocalCity",
          selectCity: "biz.util.selectCity",
          saveImage: "device.notification.saveImage",
          chooseImage: "device.notification.chooseImage",
          scan: "biz.util.scan",
          pay: "biz.util.pay",
          share: "biz.util.share",
          directShare: "biz.util.directShare",
          confirm: "device.notification.confirm",
          hidePreloader: "device.notification.hidePreloader",
          showPreloader: "device.notification.showPreloader",
          alert: "device.notification.alert",
          toast: "device.notification.toast",
          prompt: "device.notification.prompt",
          actionSheet: "device.notification.actionSheet",
          egop: "egop",
          setClipboardData: "setClipboardData",
        },
        f
      ),
      d = (function() {
        function e() {
          !(function(e, t) {
            if (!(e instanceof t))
              throw new TypeError("Cannot call a class as a function");
          })(this, e),
            (this.apiMap = p),
            (this.zlbJSBridgeReady = !1),
            (this.apiKeys = Object.keys(this.apiMap)),
            this.registerAdapterFunction(),
            this.addMethodAfterZLBJSBridgeReady(),
            this.hookZWJSBridgeOnReadyMethod();
        }
        var t, r, n;
        return (
          (t = e),
          (r = [
            {
              key: "privateJSApis",
              value: function() {
                return Object.keys(f);
              },
            },
            {
              key: "hookZWJSBridgeOnReadyMethod",
              value: function() {
                var r = this,
                  n = window.ZWJSBridge.onReady;
                window.ZWJSBridge.onReady = function(e) {
                  var t;
                  r.zlbJSBridgeReady ||
                    ((t = r.apiKeys
                      .filter(function(e) {
                        return 3 === r.apiMap[e].split(".").length;
                      })
                      .map(function(e) {
                        return "dd.".concat(r.apiMap[e]);
                      })),
                    window.dd.ready(
                      {
                        developer: "daip@dtdream.com",
                        usage: t,
                        remark: "描述业务场景",
                      },
                      function() {
                        window.ZWJSBridge.jsbridgeReady();
                      }
                    )),
                    n.call(window.ZWJSBridge, e);
                };
              },
            },
            {
              key: "addMethodAfterZLBJSBridgeReady",
              value: function() {
                var n = this;
                document.addEventListener("JSBridgeReady", function() {
                  n.apiKeys.forEach(function(e) {
                    var r = n.apiMap[e],
                      e = r.split(".");
                    3 === e.length &&
                      (window.dd[e[0]] || (window.dd[e[0]] = {}),
                      window.dd[e[0]][e[1]] || (window.dd[e[0]][e[1]] = {}),
                      window.dd[e[0]][e[1]][e[2]] ||
                        (window.dd[e[0]][e[1]][e[2]] = function(t) {
                          window.JupiterJSBridge
                            ? JupiterJSBridge.call(
                                "eGovernmentApi",
                                { apiName: r, params: t },
                                function(e) {
                                  n.bridgeCallBack(e, t);
                                }
                              )
                            : window.AlipayJSBridge
                            ? AlipayJSBridge.call(
                                "zlbCall",
                                { handlerName: r, params: t },
                                function(e) {
                                  n.bridgeCallBack(e, t);
                                }
                              )
                            : console.error("非浙里办环境");
                        }));
                  }),
                    (n.zlbJSBridgeReady = !0),
                    window.ZWJSBridge.jsbridgeReady();
                });
              },
            },
            {
              key: "bridgeCallBack",
              value: function(e, t) {
                var r = (e = "string" == typeof e ? JSON.parse(e) : e)
                  .errorCode;
                "0" === r || 0 === r
                  ? t.onSuccess && t.onSuccess(e.data || e.result || {})
                  : t.onFail && t.onFail(e);
              },
            },
            {
              key: "registerAdapterFunction",
              value: function() {
                var a = this;
                this.apiKeys.forEach(function(i) {
                  a[i] ||
                    (a[i] = function(o) {
                      return new Promise(function(t, r) {
                        var e = a.apiMap[i],
                          n = e.split(".");
                        o.onSuccess ||
                          o.onFail ||
                          (o = l(
                            l({}, o),
                            {},
                            {
                              onSuccess: function(e) {
                                return t(e);
                              },
                              onFail: function(e) {
                                return r(e);
                              },
                              onCancel: function(e) {
                                return r(e);
                              },
                              onError: function(e) {
                                return r(e);
                              },
                            }
                          )),
                          3 === n.length
                            ? window.dd[n[0]][n[1]][n[2]](o)
                            : window.JupiterJSBridge
                            ? JupiterJSBridge.call(
                                "eGovernmentApi",
                                { apiName: e, params: o },
                                function(e) {
                                  a.bridgeCallBack(e, o);
                                }
                              )
                            : console.error("非浙里办环境");
                      });
                    });
                });
              },
            },
            {
              key: "setMenu",
              value: function(t) {
                var r = this;
                window.JupiterJSBridge
                  ? JupiterJSBridge.call(
                      "eGovernmentApi",
                      { apiName: "setMenu", params: t },
                      function(e) {
                        r.bridgeCallBack(e, t);
                      }
                    )
                  : console.error("未注册浙里办");
              },
            },
          ]) && c(t.prototype, r),
          n && c(t, n),
          e
        );
      })();
    function h(t, e) {
      var r,
        n = Object.keys(t);
      return (
        Object.getOwnPropertySymbols &&
          ((r = Object.getOwnPropertySymbols(t)),
          e &&
            (r = r.filter(function(e) {
              return Object.getOwnPropertyDescriptor(t, e).enumerable;
            })),
          n.push.apply(n, r)),
        n
      );
    }
    function g(n) {
      for (var e = 1; e < arguments.length; e++) {
        var o = null != arguments[e] ? arguments[e] : {};
        e % 2
          ? h(Object(o), !0).forEach(function(e) {
              var t, r;
              (t = n),
                (e = o[(r = e)]),
                r in t
                  ? Object.defineProperty(t, r, {
                      value: e,
                      enumerable: !0,
                      configurable: !0,
                      writable: !0,
                    })
                  : (t[r] = e);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(o))
          : h(Object(o)).forEach(function(e) {
              Object.defineProperty(
                n,
                e,
                Object.getOwnPropertyDescriptor(o, e)
              );
            });
      }
      return n;
    }
    function m(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        (n.enumerable = n.enumerable || !1),
          (n.configurable = !0),
          "value" in n && (n.writable = !0),
          Object.defineProperty(e, n.key, n);
      }
    }
    var y = {};
    window.MultiportJSApis.forEach(function(e) {
      y[e] = e;
    }),
      (y.realAuthentication = "zmAuthentication");
    var v = (function() {
        function e() {
          !(function(e, t) {
            if (!(e instanceof t))
              throw new TypeError("Cannot call a class as a function");
          })(this, e),
            (this.apiMap = y),
            (this.apiKeys = Object.keys(this.apiMap)),
            this.registerAdapterFunction(),
            document.dispatchEvent(new Event("ZWJSBridgeAdapterReady"));
        }
        var t, r, n;
        return (
          (t = e),
          (r = [
            {
              key: "privateJSApis",
              value: function() {
                return [];
              },
            },
            {
              key: "bridgeCallBack",
              value: function(e, t) {
                var r = (e = "string" == typeof e ? JSON.parse(e) : e)
                  .errorCode;
                "0" === r || 0 === r
                  ? t.onSuccess && t.onSuccess(e.data || e.result || {})
                  : t.onFail && t.onFail(e);
              },
            },
            {
              key: "callJupiter",
              value: function(e, t) {
                var r = this;
                window.JupiterJSBridge
                  ? JupiterJSBridge.call(
                      "eGovernmentApi",
                      { apiName: e, params: t },
                      function(e) {
                        r.bridgeCallBack(e, t);
                      }
                    )
                  : (this.bridgeCallBack(
                      {
                        errorCode: 3,
                        errorMessage: "未注册的API",
                        success: !1,
                      },
                      t
                    ),
                    console.log(
                      "JupiterJSBridge is not supported, bridgeName = " + e
                    ));
              },
            },
            {
              key: "registerAdapterFunction",
              value: function() {
                var i = this;
                this.apiKeys.forEach(function(o) {
                  i[o] ||
                    (i[o] = function(n) {
                      return new Promise(function(t, r) {
                        n.onSuccess ||
                          n.onFail ||
                          (n = g(
                            g({}, n),
                            {},
                            {
                              onSuccess: function(e) {
                                return t(e);
                              },
                              onFail: function(e) {
                                return r(e);
                              },
                            }
                          ));
                        var e = i.apiMap[o];
                        i.callJupiter(e, n);
                      });
                    });
                });
              },
            },
            {
              key: "setMenu",
              value: function(e) {
                this.callJupiter("setMenu", e);
              },
            },
          ]) && m(t.prototype, r),
          n && m(t, n),
          e
        );
      })(),
      w = r(2),
      b = r.n(w),
      S = r(3),
      E = r.n(S);
    function C(e) {
      function c(e, t) {
        return (e << t) | (e >>> (32 - t));
      }
      function u(e, t) {
        var r = 2147483648 & e,
          n = 2147483648 & t,
          o = 1073741824 & e,
          i = 1073741824 & t,
          t = (1073741823 & e) + (1073741823 & t);
        return o & i
          ? 2147483648 ^ t ^ r ^ n
          : o | i
          ? 1073741824 & t
            ? 3221225472 ^ t ^ r ^ n
            : 1073741824 ^ t ^ r ^ n
          : t ^ r ^ n;
      }
      function t(e, t, r, n, o, i, a) {
        var s;
        return (e = u(e, u(u(((s = t) & r) | (~s & n), o), a))), u(c(e, i), t);
      }
      function r(e, t, r, n, o, i, a) {
        return (e = u(e, u(u((t & (n = n)) | (r & ~n), o), a))), u(c(e, i), t);
      }
      function n(e, t, r, n, o, i, a) {
        return (e = u(e, u(u(t ^ r ^ n, o), a))), u(c(e, i), t);
      }
      function o(e, t, r, n, o, i, a) {
        return (e = u(e, u(u(r ^ (t | ~n), o), a))), u(c(e, i), t);
      }
      function i(e) {
        for (var t = "", r = "", n = 0; n <= 3; n++)
          t += (r = "0" + ((e >>> (8 * n)) & 255).toString(16)).substr(
            r.length - 2,
            2
          );
        return t;
      }
      for (
        var a,
          s,
          l,
          f,
          p = (function(e) {
            for (
              var t,
                r = e.length,
                n = 16 * (((n = r + 8) - (n % 64)) / 64 + 1),
                o = new Array(n - 1),
                i = 0,
                a = 0;
              a < r;

            )
              (i = (a % 4) * 8),
                (o[(t = (a - (a % 4)) / 4)] = o[t] | (e.charCodeAt(a) << i)),
                a++;
            return (
              (o[(t = (a - (a % 4)) / 4)] = o[t] | (128 << (i = (a % 4) * 8))),
              (o[n - 2] = r << 3),
              (o[n - 1] = r >>> 29),
              o
            );
          })(
            (e = (function(e) {
              e = e.replace(/\r\n/g, "\n");
              for (var t = "", r = 0; r < e.length; r++) {
                var n = e.charCodeAt(r);
                n < 128
                  ? (t += String.fromCharCode(n))
                  : (127 < n && n < 2048
                      ? (t += String.fromCharCode((n >> 6) | 192))
                      : ((t += String.fromCharCode((n >> 12) | 224)),
                        (t += String.fromCharCode(((n >> 6) & 63) | 128))),
                    (t += String.fromCharCode((63 & n) | 128)));
              }
              return t;
            })(e))
          ),
          d = 1732584193,
          h = 4023233417,
          g = 2562383102,
          m = 271733878,
          y = 0;
        y < p.length;
        y += 16
      )
        (d = t((a = d), (s = h), (l = g), (f = m), p[y + 0], 7, 3614090360)),
          (m = t(m, d, h, g, p[y + 1], 12, 3905402710)),
          (g = t(g, m, d, h, p[y + 2], 17, 606105819)),
          (h = t(h, g, m, d, p[y + 3], 22, 3250441966)),
          (d = t(d, h, g, m, p[y + 4], 7, 4118548399)),
          (m = t(m, d, h, g, p[y + 5], 12, 1200080426)),
          (g = t(g, m, d, h, p[y + 6], 17, 2821735955)),
          (h = t(h, g, m, d, p[y + 7], 22, 4249261313)),
          (d = t(d, h, g, m, p[y + 8], 7, 1770035416)),
          (m = t(m, d, h, g, p[y + 9], 12, 2336552879)),
          (g = t(g, m, d, h, p[y + 10], 17, 4294925233)),
          (h = t(h, g, m, d, p[y + 11], 22, 2304563134)),
          (d = t(d, h, g, m, p[y + 12], 7, 1804603682)),
          (m = t(m, d, h, g, p[y + 13], 12, 4254626195)),
          (g = t(g, m, d, h, p[y + 14], 17, 2792965006)),
          (d = r(
            d,
            (h = t(h, g, m, d, p[y + 15], 22, 1236535329)),
            g,
            m,
            p[y + 1],
            5,
            4129170786
          )),
          (m = r(m, d, h, g, p[y + 6], 9, 3225465664)),
          (g = r(g, m, d, h, p[y + 11], 14, 643717713)),
          (h = r(h, g, m, d, p[y + 0], 20, 3921069994)),
          (d = r(d, h, g, m, p[y + 5], 5, 3593408605)),
          (m = r(m, d, h, g, p[y + 10], 9, 38016083)),
          (g = r(g, m, d, h, p[y + 15], 14, 3634488961)),
          (h = r(h, g, m, d, p[y + 4], 20, 3889429448)),
          (d = r(d, h, g, m, p[y + 9], 5, 568446438)),
          (m = r(m, d, h, g, p[y + 14], 9, 3275163606)),
          (g = r(g, m, d, h, p[y + 3], 14, 4107603335)),
          (h = r(h, g, m, d, p[y + 8], 20, 1163531501)),
          (d = r(d, h, g, m, p[y + 13], 5, 2850285829)),
          (m = r(m, d, h, g, p[y + 2], 9, 4243563512)),
          (g = r(g, m, d, h, p[y + 7], 14, 1735328473)),
          (d = n(
            d,
            (h = r(h, g, m, d, p[y + 12], 20, 2368359562)),
            g,
            m,
            p[y + 5],
            4,
            4294588738
          )),
          (m = n(m, d, h, g, p[y + 8], 11, 2272392833)),
          (g = n(g, m, d, h, p[y + 11], 16, 1839030562)),
          (h = n(h, g, m, d, p[y + 14], 23, 4259657740)),
          (d = n(d, h, g, m, p[y + 1], 4, 2763975236)),
          (m = n(m, d, h, g, p[y + 4], 11, 1272893353)),
          (g = n(g, m, d, h, p[y + 7], 16, 4139469664)),
          (h = n(h, g, m, d, p[y + 10], 23, 3200236656)),
          (d = n(d, h, g, m, p[y + 13], 4, 681279174)),
          (m = n(m, d, h, g, p[y + 0], 11, 3936430074)),
          (g = n(g, m, d, h, p[y + 3], 16, 3572445317)),
          (h = n(h, g, m, d, p[y + 6], 23, 76029189)),
          (d = n(d, h, g, m, p[y + 9], 4, 3654602809)),
          (m = n(m, d, h, g, p[y + 12], 11, 3873151461)),
          (g = n(g, m, d, h, p[y + 15], 16, 530742520)),
          (d = o(
            d,
            (h = n(h, g, m, d, p[y + 2], 23, 3299628645)),
            g,
            m,
            p[y + 0],
            6,
            4096336452
          )),
          (m = o(m, d, h, g, p[y + 7], 10, 1126891415)),
          (g = o(g, m, d, h, p[y + 14], 15, 2878612391)),
          (h = o(h, g, m, d, p[y + 5], 21, 4237533241)),
          (d = o(d, h, g, m, p[y + 12], 6, 1700485571)),
          (m = o(m, d, h, g, p[y + 3], 10, 2399980690)),
          (g = o(g, m, d, h, p[y + 10], 15, 4293915773)),
          (h = o(h, g, m, d, p[y + 1], 21, 2240044497)),
          (d = o(d, h, g, m, p[y + 8], 6, 1873313359)),
          (m = o(m, d, h, g, p[y + 15], 10, 4264355552)),
          (g = o(g, m, d, h, p[y + 6], 15, 2734768916)),
          (h = o(h, g, m, d, p[y + 13], 21, 1309151649)),
          (d = o(d, h, g, m, p[y + 4], 6, 4149444226)),
          (m = o(m, d, h, g, p[y + 11], 10, 3174756917)),
          (g = o(g, m, d, h, p[y + 2], 15, 718787259)),
          (h = o(h, g, m, d, p[y + 9], 21, 3951481745)),
          (d = u(d, a)),
          (h = u(h, s)),
          (g = u(g, l)),
          (m = u(m, f));
      return (i(d) + i(h) + i(g) + i(m)).toLowerCase();
    }
    var x = r(12),
      k = r.n(x);
    var T = function(e) {
        var t = "",
          e = k.a.get(e) || "";
        return (t = e ? e.split("_")[0] || "" : t);
      },
      t = function() {
        return new Date().getTime();
      };
    function _(e, t) {
      void 0 === t && (t = !0);
      var r,
        n = [];
      for (r in e)
        t
          ? n.push(r + "=" + encodeURIComponent(e[r]))
          : (console.log(r, e[r]), n.push(r + "=" + e[r]));
      return n.join("&");
    }
    function O(e, t) {
      for (
        var r, n = arguments.length, o = new Array(2 < n ? n - 2 : 0), i = 2;
        i < n;
        i++
      )
        o[i - 2] = arguments[i];
      (r = console).log.apply(r, ["[" + t + " " + e + "]: "].concat(o));
    }
    function A() {}
    var R = ["error", "warning", "log", "debug"];
    function j() {
      var e = window.localStorage.getItem("jssdk_log_level") || "error";
      return R.indexOf(e);
    }
    var n = A,
      w = A,
      S = A,
      x = A,
      x = {
        debug: (n =
          3 <= j()
            ? function(e) {
                for (
                  var t = arguments.length,
                    r = new Array(1 < t ? t - 1 : 0),
                    n = 1;
                  n < t;
                  n++
                )
                  r[n - 1] = arguments[n];
                O.apply(void 0, ["DEBUG", e].concat(r));
              }
            : n),
        log: (S =
          2 <= j()
            ? function(e) {
                for (
                  var t = arguments.length,
                    r = new Array(1 < t ? t - 1 : 0),
                    n = 1;
                  n < t;
                  n++
                )
                  r[n - 1] = arguments[n];
                O.apply(void 0, ["LOG", e].concat(r));
              }
            : S),
        warning: (x =
          1 <= j()
            ? function(e) {
                for (
                  var t = arguments.length,
                    r = new Array(1 < t ? t - 1 : 0),
                    n = 1;
                  n < t;
                  n++
                )
                  r[n - 1] = arguments[n];
                O.apply(void 0, ["WARNING", e].concat(r));
              }
            : x),
        error: (w =
          0 <= j()
            ? function(e) {
                for (
                  var t = arguments.length,
                    r = new Array(1 < t ? t - 1 : 0),
                    n = 1;
                  n < t;
                  n++
                )
                  r[n - 1] = arguments[n];
                O.apply(void 0, ["ERROR", e].concat(r));
              }
            : w),
      },
      P = x.log,
      I = x.debug;
    function B() {
      var e = window.navigator.userAgent.toLowerCase();
      I("UserAgent: " + e);
      var t = -1 < e.indexOf("dtdreamweb"),
        r = -1 < e.indexOf("hanweb") && !t,
        n = -1 < e.indexOf("micromessenger"),
        o = -1 < e.indexOf("alipayclient"),
        i =
          (-1 < e.indexOf("miniprogram") || -1 < e.indexOf("alipayide")) &&
          -1 < e.indexOf("alipay"),
        a = -1 < e.indexOf("eshiminapp"),
        s = -1 < e.indexOf("iflytek_mmp"),
        c = -1 < e.indexOf("miniprogram") && -1 < e.indexOf("dingtalk"),
        u = -1 < e.indexOf("dingtalk"),
        l = -1 < e.indexOf("000001@jcss"),
        e = window.ReactNativeWebView;
      return t
        ? "dtdream"
        : r
        ? "hanweb"
        : a
        ? "eshimin"
        : s
        ? "iflytek"
        : n
        ? "wetchat"
        : c
        ? "dingtalkMini"
        : u
        ? "dingtalk"
        : i
        ? "alipayMini"
        : o
        ? "alipay"
        : e
        ? "reactNative"
        : l
        ? "JCSS"
        : "other";
    }
    var D,
      L,
      N = {
        isJCSS: function() {
          return "JCSS" === B();
        },
        isAlipay: function() {
          return "alipay" === B();
        },
        isAlipayMini: function() {
          var e = B();
          return I("isAlipayMini type: " + e), "alipayMini" === e;
        },
        isDtdreamApp: function() {
          return "dtdream" === B();
        },
        isHanApp: function() {
          return "hanweb" === B();
        },
        isEshiminApp: function() {
          return "eshimin" === B();
        },
        isIflytek: function() {
          return "iflytek" === B();
        },
        isDingtalkMini: function() {
          return "dingtalkMini" === B();
        },
        isDingtalk: function() {
          return "dingtalk" === B();
        },
        isReactNative: function() {
          var e = B();
          return P("current env", "react native"), "reactNative" === e;
        },
      },
      J = "//pre-mapi.zjzwfw.gov.cn",
      H = "//47.96.150.251:8068",
      U = function(e, t) {
        return t
          ? /\/$/.test(t)
            ? t.slice(0, -1)
            : t
          : "daily" === e
          ? H
          : "pre" === e
          ? J
          : "//" + window.location.host;
      },
      M = {
        ResultSuccess: 1e3,
        PermissionDeny: 1001,
        InvokeExceedLimit: 1002,
        OperationTypeMissed: 3e3,
        RequestDataMissed: 3001,
        ValueInvalid: 3002,
        RequestParamMissed: 3004,
        AppNotExist: 3005,
        SubscribeNotExist: 3006,
        RequestTimeOut: 4001,
        RemoteAccessException: 4002,
        CallHsfTimeout: 4005,
        UnknowError: 5e3,
        CorsOptions: 8002,
        FAIL_SYS_TOKEN_EMPTY: 9001,
        FAIL_SYS_TOKEN_ILLEGAL: 9002,
        FAIL_SYS_TOKEN_EXOIRED: 9003,
      };
    ((w = D = D || {}).GET = "GET"),
      (w.POST = "POST"),
      (w.DELETE = "DELETE"),
      (w.Options = "Options"),
      (w.PUT = "PUT"),
      (w.PATCH = "PATCH"),
      ((w = {}).H5 = "H5"),
      (w.Native = "Native"),
      ((w = L = L || {}).JSON = "JSON"),
      (w.JSONP = "JSONP");
    var F = function(e, a, s, c) {
        return new (s = s || Promise)(function(r, t) {
          function n(e) {
            try {
              i(c.next(e));
            } catch (e) {
              t(e);
            }
          }
          function o(e) {
            try {
              i(c.throw(e));
            } catch (e) {
              t(e);
            }
          }
          function i(e) {
            var t;
            e.done
              ? r(e.value)
              : ((t = e.value) instanceof s
                  ? t
                  : new s(function(e) {
                      e(t);
                    })
                ).then(n, o);
          }
          i((c = c.apply(e, a || [])).next());
        });
      },
      q = x.debug,
      z = x.warning,
      G = T,
      K = t,
      W = "_mgw_tk",
      X = "jl9vupjh+200100201+nytcfro",
      Z = 2,
      $ = (D.POST, D.PATCH, D.PUT, "mgop"),
      Q = "1000::调用成功",
      Y = {},
      V = (function() {
        function e(e) {
          (this.times = 0),
            (this.config = Object.assign({}, { env: "online", header: {} }, e)),
            q($, "Mgop init with params", this.config);
        }
        var t = e.prototype;
        return (
          (t.isJupiterJSBridge = function() {
            var e =
              -1 < window.navigator.userAgent.toLowerCase().indexOf("jupiter");
            return !(!window.JupiterJSBridge || !e);
          }),
          (t.createParam = function(e, t) {
            var r = this.config.api;
            return {
              api: void 0 === r ? "" : r,
              data: (e = void 0 === e ? {} : e),
              ret: "string" == typeof t ? [t] : t,
            };
          }),
          (t.createSuccessCb = function(e) {
            return this.createParam(e, Q);
          }),
          (t.createFailCb = function(e) {
            return this.createParam({}, e);
          }),
          (t.processToken = function(e, t) {
            t = _(
              {
                token: G(W) || "",
                ak: this.config.appKey || X,
                api: this.config.api || "",
                ts: e,
                data: t,
              },
              !1
            );
            return q($, "processToken params", t), C(t);
          }),
          (t.processRequestUrl = function() {
            var e,
              t = U(this.config.env, this.config.host),
              r = K(),
              e =
                ((n = this.config),
                (e = n.type || D.GET),
                (n = n.data),
                (e !== D.POST && JSON.stringify(n)) || ""),
              n = this.processToken(r, e),
              n =
                "" +
                _({
                  ak: this.config.appKey || X,
                  api: this.config.api,
                  ts: r,
                  data: e,
                  sign: n,
                });
            return { url: t + "/h5/mgop?" + n, query: n };
          }),
          (t.processResponseResult = function(e) {
            void 0 === e && (e = {});
            var t = Number(e.rs);
            switch (t) {
              case M.ResultSuccess:
                return this.createSuccessCb(e.data || {});
              case M.FAIL_SYS_TOKEN_EMPTY:
                return (q($, M.FAIL_SYS_TOKEN_EMPTY, "令牌为空，重试"),
                this.times < Z)
                  ? (this.times++, this.doSequence())
                  : (q(
                      $,
                      M.FAIL_SYS_TOKEN_EMPTY,
                      "令牌为空，且超过最大重试次数"
                    ),
                    "");
              default:
                throw (z($, "response fail", t), this.createFailCb(e.ret));
            }
          }),
          (t.processRequest = function() {
            return F(
              this,
              void 0,
              void 0,
              b.a.mark(function e() {
                var t, r, n, o, i, a, s, c, u;
                return b.a.wrap(
                  function(e) {
                    for (;;)
                      switch ((e.prev = e.next)) {
                        case 0:
                          if (
                            ((e.prev = 0),
                            (t = this.config.dataType || L.JSONP),
                            (r = this.config.type || D.GET),
                            (a = this.processRequestUrl()),
                            (n = a.url),
                            (o = a.query),
                            (i = Y),
                            Object.assign(i, this.config.header),
                            (a = null),
                            t !== L.JSON)
                          ) {
                            e.next = 40;
                            break;
                          }
                          if (
                            ((s = window),
                            (s = s.my),
                            !(N.isAlipayMini() && s && s.AlipayMiniAppCall))
                          ) {
                            e.next = 25;
                            break;
                          }
                          if ((q($, r, "小程序 CORS 跨域请求"), r === D.GET))
                            return (
                              (e.next = 14),
                              s.AlipayMiniAppCall("mgop", {
                                method: r,
                                query: o,
                                headers: i,
                              })
                            );
                          e.next = 18;
                          break;
                        case 14:
                          (c = e.sent), (a = c ? c.data : null), (e.next = 23);
                          break;
                        case 18:
                          if (r === D.POST)
                            return (
                              (e.next = 21),
                              s.AlipayMiniAppCall("mgop", {
                                method: r,
                                query: o,
                                headers: i,
                                data: this.config.data || {},
                              })
                            );
                          e.next = 23;
                          break;
                        case 21:
                          (c = e.sent), (a = c ? c.data : null);
                        case 23:
                          e.next = 38;
                          break;
                        case 25:
                          if ((q($, r, "H5 CORS 跨域请求"), r === D.GET))
                            return (
                              (e.next = 29),
                              E.a.get(n, { headers: i, withCredentials: !0 })
                            );
                          e.next = 33;
                          break;
                        case 29:
                          (u = e.sent), (a = u ? u.data : null), (e.next = 38);
                          break;
                        case 33:
                          if (r === D.POST)
                            return (
                              (e.next = 36),
                              E.a.post(n, this.config.data || {}, {
                                headers: i,
                                withCredentials: !0,
                              })
                            );
                          e.next = 38;
                          break;
                        case 36:
                          (u = e.sent), (a = u ? u.data : null);
                        case 38:
                          e.next = 44;
                          break;
                        case 40:
                          return (
                            q($, "JSONP 请求"),
                            (e.next = 43),
                            E.a.jsonp(n, { headers: i })
                          );
                        case 43:
                          a = e.sent;
                        case 44:
                          if (a) {
                            e.next = 46;
                            break;
                          }
                          throw new Error("返回为空");
                        case 46:
                          return (
                            q($, "response", a),
                            e.abrupt("return", this.processResponseResult(a))
                          );
                        case 50:
                          throw ((e.prev = 50),
                          (e.t0 = e.catch(0)),
                          z(
                            $,
                            JSON.stringify(e.t0 || ""),
                            "processRequest error"
                          ),
                          e.t0);
                        case 54:
                        case "end":
                          return e.stop();
                      }
                  },
                  e,
                  this,
                  [[0, 50]]
                );
              })
            );
          }),
          (t.doSequence = function() {
            return F(
              this,
              void 0,
              void 0,
              b.a.mark(function e() {
                var t;
                return b.a.wrap(
                  function(e) {
                    for (;;)
                      switch ((e.prev = e.next)) {
                        case 0:
                          return (
                            (e.prev = 0), (e.next = 3), this.processRequest()
                          );
                        case 3:
                          return (t = e.sent), e.abrupt("return", t);
                        case 7:
                          throw ((e.prev = 7), (e.t0 = e.catch(0)), e.t0);
                        case 10:
                        case "end":
                          return e.stop();
                      }
                  },
                  e,
                  this,
                  [[0, 7]]
                );
              })
            );
          }),
          (t.request = function(r) {
            return (
              void 0 === r && (r = {}),
              F(
                this,
                void 0,
                void 0,
                b.a.mark(function e() {
                  var t;
                  return b.a.wrap(
                    function(e) {
                      for (;;)
                        switch ((e.prev = e.next)) {
                          case 0:
                            return (
                              (e.prev = 0), (e.next = 3), this.doSequence()
                            );
                          case 3:
                            (t = e.sent),
                              r.successCallback && r.successCallback(t),
                              (e.next = 10);
                            break;
                          case 7:
                            (e.prev = 7),
                              (e.t0 = e.catch(0)),
                              r.failureCallback && r.failureCallback(e.t0);
                          case 10:
                          case "end":
                            return e.stop();
                        }
                    },
                    e,
                    this,
                    [[0, 7]]
                  );
                })
              )
            );
          }),
          (t.egop = function(l) {
            return (
              void 0 === l && (l = {}),
              F(
                this,
                void 0,
                void 0,
                b.a.mark(function e() {
                  var t, r, n, o, i, a, s, c, u;
                  return b.a.wrap(function(e) {
                    for (;;)
                      switch ((e.prev = e.next)) {
                        case 0:
                          (s = window),
                            (t = s.JupiterJSBridge),
                            (r = (u = l || {}).api),
                            (n = u.data),
                            (o = u.type),
                            (i = u.appKey),
                            (s = u.onSuccess),
                            (a =
                              void 0 === s
                                ? function(e) {
                                    console.log(
                                      "egop on default success result:",
                                      e
                                    );
                                  }
                                : s),
                            (s = u.onFail),
                            (c =
                              void 0 === s
                                ? function(e) {
                                    console.log(
                                      "egop on default fail result:",
                                      e
                                    );
                                  }
                                : s),
                            (u = u.header),
                            (u = void 0 === u ? {} : u),
                            q($, "call jupiter with param", r),
                            t.call(
                              "eGovernmentApi",
                              {
                                apiName: "egop",
                                params: {
                                  method: o,
                                  param: n,
                                  api: r,
                                  header: Object.assign({ "extra-ak": i }, u),
                                },
                              },
                              function(e) {
                                console.log("egop get result:", e);
                                var t = (e =
                                  "string" == typeof e ? JSON.parse(e) : e)
                                  .errorCode;
                                "0" === t || 0 === t
                                  ? a({
                                      api: r,
                                      data: e.data || e.result || {},
                                      ret: [Q],
                                    })
                                  : c(e);
                              }
                            );
                        case 4:
                        case "end":
                          return e.stop();
                      }
                  }, e);
                })
              )
            );
          }),
          e
        );
      })();
    var ee = window.navigator.userAgent.toLowerCase();
    console.log("zwjsbridge begin load, ua ==== " + ee);
    var te,
      r = r(33).singleton({
        pid: "i1p1ziwgub@4cbaed85d8c53b3",
        appType: "web",
        imgUrl: "https://arms-retcode.aliyuncs.com/r.png?",
        behavior: !0,
        disableHook: !0,
        sendResource: !0,
        enableLinkTrace: !0,
      });
    (window.__zwbl = r),
      -1 != ee.indexOf("zlb") || -1 != ee.indexOf("dtdream")
        ? (console.log("in zlb env"),
          document.writeln(
            '<script type="text/javascript" src="//portal.zjzwfw.gov.cn/assets/jsbridge/1.0.0/jsbridge.js"></script>'
          ),
          (d = new d()),
          window.ZWJSBridge.registerAdapter(d),
          window.__zwbl.sum("userAgent_zlb", 1))
        : -1 != ee.indexOf("jcss")
        ? (console.log("in JCSS env"),
          (te = new v()),
          window.ZWJSBridge.registerAdapter(te),
          window.__zwbl.sum("userAgent_jcss", 1))
        : -1 != ee.indexOf("jupiter")
        ? (console.log("in Jupiter env"),
          (te = new v()),
          window.ZWJSBridge.registerAdapter(te),
          window.__zwbl.sum("userAgent_jupiter", 1))
        : (console.log("fetch adapter remote"),
          -1 != ee.indexOf("alipayclient")
            ? window.__zwbl.sum("userAgent_alipay", 1)
            : -1 != ee.indexOf("wechat")
            ? window.__zwbl.sum("userAgent_wechat:" + window.location.href, 1)
            : window.__zwbl.sum("userAgent_other:" + ee, 1),
          (function(e) {
            q($, "call mgop with param", (e = void 0 === e ? {} : e));
            var t = new V(e);
            if (t.isJupiterJSBridge()) return t.egop(e);
            e = { successCallback: e.onSuccess, failureCallback: e.onFail };
            q($, "_mgop request options", e), t.request(e);
          })({
            api: "mgop.gov.jsadapter.query",
            host: "https://mapi.zjzwfw.gov.cn/",
            data: { appType: "js_adapter" },
            dataType: "JSON",
            type: "GET",
            appKey: "94sdprt8+2001000801+sxzaia",
            onSuccess: function(e) {
              var t,
                r = !1;
              if (
                (console.log("data", e),
                e && e.data && e.data.data && 0 < e.data.data.length)
              )
                for (var n = 0; n < e.data.data.length; n++) {
                  var o = e.data.data[n];
                  if (o.ext) {
                    var i = JSON.parse(o.ext);
                    if (i.ua && -1 != ee.indexOf(i.ua.toLowerCase()) && o.url) {
                      var a = JSON.parse(o.url);
                      if (a.url) {
                        i = a.url + "/index.js";
                        console.log("begin load script: " + i);
                        (o = document.getElementsByTagName("head")[0]),
                          (a = document.createElement("script"));
                        (a.type = "text/javascript"),
                          (a.src = i),
                          (a.onload = function() {}),
                          o.appendChild(a),
                          (r = !0);
                        break;
                      }
                    }
                  }
                }
              r ||
                (console.log("no matched, begin register commonAdapter"),
                (t = new v()),
                window.ZWJSBridge.registerAdapter(t));
            },
            onFail: function(e) {
              console.log(e, "err");
              e = new v();
              window.ZWJSBridge.registerAdapter(e);
            },
          }));
  },
]);



// WEBPACK FOOTER //
// ./src/router/zwjsbridge.js